"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteUrls = exports.CatalogUrlParamKeys = void 0;
var util_1 = require("./util");
var CatalogUrlParamKeys;
(function (CatalogUrlParamKeys) {
    CatalogUrlParamKeys.column = 'column';
    CatalogUrlParamKeys.embeddedDataSource = 'embeddedDataSource';
    CatalogUrlParamKeys.field = 'field';
    CatalogUrlParamKeys.order = 'order';
    CatalogUrlParamKeys.outputStep = 'outputStep';
    CatalogUrlParamKeys.search = 'search';
    CatalogUrlParamKeys.table = 'table';
})(CatalogUrlParamKeys = exports.CatalogUrlParamKeys || (exports.CatalogUrlParamKeys = {}));
function tagParam(tag) {
    return 'tag=' + (0, util_1.encodeUriQuery)(tag);
}
function deviceTypeParam(deviceType) {
    return ':device=' + (0, util_1.encodeUriQuery)(deviceType);
}
var SiteUrls = /** @class */ (function () {
    function SiteUrls(config) {
        if (config.queryString && config.queryString.length > 0) {
            // Prepend a '?' if missing
            this.queryString =
                (config.queryString[0] === '?' ? '' : '?') + config.queryString;
        }
        else {
            this.queryString = '';
        }
        this.sitePrefix = SiteUrls.makeSitePrefix(config.siteUrlName);
        this.vizClientSitePrefix = SiteUrls.makeVizClientSitePrefix(config.siteUrlName);
    }
    // Returns a copy of SiteUrls modified for a different siteUrlName
    SiteUrls.prototype.forSiteName = function (siteName) {
        return new SiteUrls({
            siteUrlName: siteName,
            queryString: this.queryString,
        });
    };
    // The full url is prefixed by the query string and puts the path in the hash.
    SiteUrls.prototype.fullUrl = function (path) {
        return "/".concat(this.queryString, "#").concat(path);
    };
    // A site path is a path starting with /site/<siteUrlName>
    SiteUrls.prototype.sitePath = function (path) {
        return "".concat(this.sitePrefix).concat(path);
    };
    SiteUrls.makeSitePrefix = function (siteUrlName) {
        return siteUrlName && siteUrlName.length > 0 ? "/site/".concat(siteUrlName) : '';
    };
    SiteUrls.prototype.defaultUrl = function () {
        return this.fullUrl(this.defaultPath());
    };
    SiteUrls.prototype.defaultPath = function () {
        return this.sitePath('/');
    };
    // Data Catalog
    SiteUrls.prototype.catalogUrl = function () {
        return this.fullUrl(this.catalogPath());
    };
    SiteUrls.prototype.catalogPath = function () {
        return this.sitePath(SiteUrls.catalogPart());
    };
    SiteUrls.catalogPart = function () {
        return '/catalog';
    };
    // Data Catalog shared parts
    SiteUrls.columnsPart = function () {
        return '/columns';
    };
    SiteUrls.dashboardsPart = function () {
        return '/dashboards';
    };
    SiteUrls.databasesPart = function () {
        return '/databases';
    };
    SiteUrls.downstreamPart = function () {
        return '/downstream';
    };
    SiteUrls.fieldsPart = function () {
        return '/fields';
    };
    SiteUrls.lineagePart = function () {
        return '/lineage';
    };
    SiteUrls.lineageMetricsPart = function () {
        return '/metrics';
    };
    SiteUrls.ownersPart = function () {
        return '/owners';
    };
    SiteUrls.sheetsPart = function () {
        return '/sheets';
    };
    SiteUrls.tablesPart = function () {
        return '/tables';
    };
    SiteUrls.upstreamPart = function () {
        return '/upstream';
    };
    SiteUrls.filesPart = function () {
        return '/files';
    };
    SiteUrls.externalAssetsShowAllPart = function () {
        return '/externalassets';
    };
    // Table
    SiteUrls.prototype.catalogTablesUrl = function () {
        return this.fullUrl(this.catalogTablesPath());
    };
    SiteUrls.prototype.catalogTablesPath = function () {
        return this.sitePath(SiteUrls.catalogTablesPart());
    };
    SiteUrls.catalogTablesPart = function () {
        return "".concat(SiteUrls.catalogPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.catalogTableUrl = function (tableId) {
        return this.fullUrl(this.catalogTablePath(tableId));
    };
    SiteUrls.prototype.catalogTablePath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTablePart(tableId));
    };
    SiteUrls.catalogTablePart = function (tableId) {
        return "".concat(SiteUrls.catalogTablesPart(), "/").concat(tableId);
    };
    SiteUrls.prototype.catalogTableColumnsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableColumnsPath(tableId));
    };
    SiteUrls.prototype.catalogTableColumnsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableColumnsPart(tableId));
    };
    SiteUrls.catalogTableColumnsPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.columnsPart());
    };
    SiteUrls.prototype.catalogTableColumnUrl = function (tableId, columnId) {
        return this.fullUrl(this.catalogTableColumnPath(tableId, columnId));
    };
    SiteUrls.prototype.catalogTableColumnPath = function (tableId, columnId) {
        return this.sitePath(SiteUrls.catalogTableColumnPart(tableId, columnId));
    };
    SiteUrls.catalogTableColumnPart = function (tableId, columnId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.columnsPart(), "/").concat(columnId);
    };
    SiteUrls.prototype.catalogTableUpstreamDatabasesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableUpstreamDatabasesPath(tableId));
    };
    SiteUrls.prototype.catalogTableUpstreamDatabasesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableUpstreamDatabasesPart(tableId));
    };
    SiteUrls.catalogTableUpstreamDatabasesPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.catalogTableUpstreamTablesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableUpstreamTablesPath(tableId));
    };
    SiteUrls.prototype.catalogTableUpstreamTablesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableUpstreamTablesPart(tableId));
    };
    SiteUrls.catalogTableUpstreamTablesPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.catalogTableUpstreamFlowsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableUpstreamFlowsPath(tableId));
    };
    SiteUrls.prototype.catalogTableUpstreamFlowsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableUpstreamFlowsPart(tableId));
    };
    SiteUrls.catalogTableUpstreamFlowsPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.catalogTableUpstreamDatasourcesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableUpstreamDatasourcesPath(tableId));
    };
    SiteUrls.prototype.catalogTableUpstreamDatasourcesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableUpstreamDatasourcesPart(tableId));
    };
    SiteUrls.catalogTableUpstreamDatasourcesPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.catalogTableDownstreamDatabasesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamDatabasesPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamDatabasesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamDatabasesPart(tableId));
    };
    SiteUrls.catalogTableDownstreamDatabasesPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.catalogTableDownstreamTablesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamTablesPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamTablesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamTablesPart(tableId));
    };
    SiteUrls.catalogTableDownstreamTablesPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.catalogTableDownstreamVirtualConnectionsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamVirtualConnectionsPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamVirtualConnectionsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamVirtualConnectionsPart(tableId));
    };
    SiteUrls.catalogTableDownstreamVirtualConnectionsPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.virtualConnectionsPart());
    };
    SiteUrls.prototype.catalogTableDownstreamVirtualConnectionTablesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamVirtualConnectionTablesPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamVirtualConnectionTablesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamVirtualConnectionTablesPart(tableId));
    };
    SiteUrls.catalogTableDownstreamVirtualConnectionTablesPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.virtualConnectionTablesPart());
    };
    SiteUrls.prototype.catalogTableDownstreamFlowsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamFlowsPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamFlowsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamFlowsPart(tableId));
    };
    SiteUrls.catalogTableDownstreamFlowsPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.catalogTableDownstreamMetricDefinitionsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamMetricDefinitionsPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamMetricDefinitionsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamMetricDefinitionsPart(tableId));
    };
    SiteUrls.catalogTableDownstreamMetricDefinitionsPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.metricDefinitionsPart());
    };
    SiteUrls.prototype.catalogTableDownstreamDatasourcesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamDatasourcesPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamDatasourcesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamDatasourcesPart(tableId));
    };
    SiteUrls.catalogTableDownstreamDatasourcesPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.catalogTableDownstreamLensesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamLensesPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamLensesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamLensesPart(tableId));
    };
    SiteUrls.catalogTableDownstreamLensesPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lensesPart());
    };
    SiteUrls.prototype.catalogTableDownstreamWorkbooksUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamWorkbooksPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamWorkbooksPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamWorkbooksPart(tableId));
    };
    SiteUrls.catalogTableDownstreamWorkbooksPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.workbooksPart());
    };
    SiteUrls.prototype.catalogTableDownstreamDashboardsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamDashboardsPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamDashboardsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamDashboardsPart(tableId));
    };
    SiteUrls.catalogTableDownstreamDashboardsPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.dashboardsPart());
    };
    SiteUrls.prototype.catalogTableDownstreamSheetsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamSheetsPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamSheetsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamSheetsPart(tableId));
    };
    SiteUrls.catalogTableDownstreamSheetsPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.sheetsPart());
    };
    SiteUrls.prototype.catalogTableDownstreamMetricsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamMetricsPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamMetricsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamMetricsPart(tableId));
    };
    SiteUrls.catalogTableDownstreamMetricsPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lineageMetricsPart());
    };
    SiteUrls.prototype.catalogTableDownstreamOwnersUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamOwnersPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamOwnersPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamOwnersPart(tableId));
    };
    SiteUrls.catalogTableDownstreamOwnersPart = function (tableId) {
        return "".concat(SiteUrls.catalogTablePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.ownersPart());
    };
    // Database
    SiteUrls.prototype.catalogDatabasesUrl = function () {
        return this.fullUrl(this.catalogDatabasesPath());
    };
    SiteUrls.prototype.catalogDatabasesPath = function () {
        return this.sitePath(SiteUrls.catalogDatabasesPart());
    };
    SiteUrls.catalogDatabasesPart = function () {
        return "".concat(SiteUrls.catalogPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.catalogDatabaseUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabasePath(databaseId));
    };
    SiteUrls.prototype.catalogDatabasePath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabasePart(databaseId));
    };
    SiteUrls.catalogDatabasePart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasesPart(), "/").concat(databaseId);
    };
    SiteUrls.prototype.catalogDatabaseTablesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseTablesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseTablesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseTablesPart(databaseId));
    };
    SiteUrls.catalogDatabaseTablesPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.catalogDatabaseUpstreamDatabasesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseUpstreamDatabasesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseUpstreamDatabasesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseUpstreamDatabasesPart(databaseId));
    };
    SiteUrls.catalogDatabaseUpstreamDatabasesPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.catalogDatabaseUpstreamTablesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseUpstreamTablesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseUpstreamTablesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseUpstreamTablesPart(databaseId));
    };
    SiteUrls.catalogDatabaseUpstreamTablesPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.catalogDatabaseUpstreamFlowsUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseUpstreamFlowsPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseUpstreamFlowsPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseUpstreamFlowsPart(databaseId));
    };
    SiteUrls.catalogDatabaseUpstreamFlowsPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.catalogDatabaseUpstreamDatasourcesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseUpstreamDatasourcesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseUpstreamDatasourcesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseUpstreamDatasourcesPart(databaseId));
    };
    SiteUrls.catalogDatabaseUpstreamDatasourcesPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreamDatabasesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamDatabasesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamDatabasesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamDatabasesPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamDatabasesPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreamTablesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamTablesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamTablesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamTablesPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamTablesPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreamVirtualConnectionsUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamVirtualConnectionsPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamVirtualConnectionsPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamVirtualConnectionsPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamVirtualConnectionsPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.virtualConnectionsPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreamVirtualConnectionTablesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamVirtualConnectionTablesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamVirtualConnectionTablesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamVirtualConnectionTablesPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamVirtualConnectionTablesPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.virtualConnectionTablesPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreamFlowsUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamFlowsPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamFlowsPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamFlowsPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamFlowsPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreamMetricDefinitionsUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamMetricDefinitionsPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamMetricDefinitionsPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamMetricDefinitionsPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamMetricDefinitionsPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.metricDefinitionsPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreamDatasourcesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamDatasourcesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamDatasourcesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamDatasourcesPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamDatasourcesPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreamLensesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamLensesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamLensesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamLensesPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamLensesPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lensesPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreamWorkbooksUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamWorkbooksPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamWorkbooksPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamWorkbooksPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamWorkbooksPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.workbooksPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreamDashboardsUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamDashboardsPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamDashboardsPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamDashboardsPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamDashboardsPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.dashboardsPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreamSheetsUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamSheetsPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamSheetsPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamSheetsPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamSheetsPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.sheetsPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreaMetricsUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamMetricsPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamMetricsPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamMetricsPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamMetricsPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lineageMetricsPart());
    };
    SiteUrls.prototype.catalogDatabaseDownstreamOwnersUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamOwnersPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamOwnersPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamOwnersPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamOwnersPart = function (databaseId) {
        return "".concat(SiteUrls.catalogDatabasePart(databaseId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.ownersPart());
    };
    SiteUrls.prototype.catalogDatabasesWithTagUrl = function (tag) {
        return this.fullUrl(this.catalogDatabasesWithTagPath(tag));
    };
    SiteUrls.prototype.catalogDatabasesWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.catalogDatabasesWithTagPart(tag));
    };
    SiteUrls.catalogDatabasesWithTagPart = function (tag) {
        return "".concat(SiteUrls.catalogDatabasesPart()).concat(SiteUrls.tagPart(tag));
    };
    SiteUrls.prototype.catalogTablesWithTagUrl = function (tag) {
        return this.fullUrl(this.catalogTablesWithTagPath(tag));
    };
    SiteUrls.prototype.catalogTablesWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.catalogTablesWithTagPart(tag));
    };
    SiteUrls.catalogTablesWithTagPart = function (tag) {
        return "".concat(SiteUrls.catalogTablesPart()).concat(SiteUrls.tagPart(tag));
    };
    // Explore
    SiteUrls.prototype.exploreUrl = function () {
        return this.fullUrl(this.explorePath());
    };
    SiteUrls.prototype.explorePath = function () {
        return this.sitePath(SiteUrls.explorePart());
    };
    SiteUrls.explorePart = function () {
        return '/explore';
    };
    // DataRole
    SiteUrls.prototype.dataRolesUrl = function () {
        return this.fullUrl(this.dataRolesPath());
    };
    SiteUrls.prototype.dataRolesPath = function () {
        return this.sitePath(SiteUrls.dataRolesPart());
    };
    SiteUrls.dataRolesPart = function () {
        return '/dataRoles';
    };
    SiteUrls.prototype.dataRoleUrl = function (roleId) {
        return this.fullUrl(this.dataRolePath(roleId));
    };
    SiteUrls.prototype.dataRolePath = function (roleId) {
        return this.sitePath(SiteUrls.dataRolePart(roleId));
    };
    SiteUrls.dataRolePart = function (roleId) {
        return "".concat(SiteUrls.dataRolesPart(), "/").concat(roleId);
    };
    SiteUrls.prototype.redirectToDataRoleUrl = function (roleId) {
        return this.fullUrl(this.redirectToDataRolePath(roleId));
    };
    SiteUrls.prototype.redirectToDataRolePath = function (roleId) {
        return this.sitePath(SiteUrls.redirectToDataRolePart(roleId));
    };
    SiteUrls.redirectToDataRolePart = function (roleId) {
        return "/redirect_to_data_role/".concat(roleId);
    };
    SiteUrls.prototype.dataRoleConnectedFlowsUrl = function (roleId) {
        return this.fullUrl(this.dataRoleConnectedFlowsPath(roleId));
    };
    SiteUrls.prototype.dataRoleConnectedFlowsPath = function (roleId) {
        return this.sitePath(SiteUrls.dataRoleConnectedFlowsPart(roleId));
    };
    SiteUrls.dataRoleConnectedFlowsPart = function (roleId) {
        return "".concat(SiteUrls.dataRolesPart(), "/").concat(roleId).concat(this.connectedFlowsPart());
    };
    SiteUrls.connectedFlowsPart = function () {
        return '/connectedFlows';
    };
    SiteUrls.prototype.dataRoleConnectedDatasourcesUrl = function (roleId) {
        return this.fullUrl(this.dataRoleConnectedDatasourcesPath(roleId));
    };
    SiteUrls.prototype.dataRoleConnectedDatasourcesPath = function (roleId) {
        return this.sitePath(SiteUrls.dataRoleConnectedDatasourcesPart(roleId));
    };
    SiteUrls.dataRoleConnectedDatasourcesPart = function (roleId) {
        return "".concat(SiteUrls.dataRolesPart(), "/").concat(roleId).concat(this.connectedDatasourcesPart());
    };
    SiteUrls.connectedDatasourcesPart = function () {
        return '/connectedDatasources';
    };
    SiteUrls.prototype.dataRoleDefinitionUrl = function (roleId) {
        return this.fullUrl(this.dataRoleDefinitionPath(roleId));
    };
    SiteUrls.prototype.dataRoleDefinitionPath = function (roleId) {
        return this.sitePath(SiteUrls.dataRoleDefinitionPart(roleId));
    };
    SiteUrls.dataRoleDefinitionPart = function (roleId) {
        return "".concat(SiteUrls.dataRolesPart(), "/").concat(roleId).concat(this.definitionPart());
    };
    SiteUrls.definitionPart = function () {
        return '/definition';
    };
    // Files
    SiteUrls.prototype.catalogFilesUrl = function () {
        return this.fullUrl(this.catalogFilesPath());
    };
    SiteUrls.prototype.catalogFilesPath = function () {
        return this.sitePath(SiteUrls.catalogFilesPart());
    };
    SiteUrls.catalogFilesPart = function () {
        return "".concat(SiteUrls.catalogPart()).concat(SiteUrls.filesPart());
    };
    SiteUrls.prototype.filesUrl = function () {
        return this.fullUrl(this.filesPath());
    };
    SiteUrls.prototype.filesPath = function () {
        return this.sitePath(SiteUrls.filesPart());
    };
    // Show all external assets
    SiteUrls.prototype.catalogExternalAssetsShowAllUrl = function () {
        return this.fullUrl(this.catalogExternalAssetsShowAllPath());
    };
    SiteUrls.prototype.catalogExternalAssetsShowAllPath = function () {
        return this.sitePath(SiteUrls.catalogExternalAssetsShowAllPart());
    };
    SiteUrls.catalogExternalAssetsShowAllPart = function () {
        return "".concat(SiteUrls.catalogPart()).concat(SiteUrls.externalAssetsShowAllPart());
    };
    SiteUrls.prototype.externalAssetsShowAllUrl = function () {
        return this.fullUrl(this.externalAssetsShowAllPath());
    };
    SiteUrls.prototype.externalAssetsShowAllPath = function () {
        return this.sitePath(SiteUrls.externalAssetsShowAllPart());
    };
    // Lenses
    SiteUrls.prototype.lensesUrl = function () {
        return this.fullUrl(this.lensesPath());
    };
    SiteUrls.prototype.lensesPath = function () {
        return this.sitePath(SiteUrls.lensesPart());
    };
    SiteUrls.lensesPart = function () {
        return '/lenses';
    };
    SiteUrls.prototype.lensUrl = function (lensId) {
        return this.fullUrl(this.lensPath(lensId));
    };
    SiteUrls.prototype.lensPath = function (lensId) {
        return this.sitePath(SiteUrls.lensPart(lensId));
    };
    SiteUrls.lensPart = function (lensId) {
        return "".concat(SiteUrls.lensesPart(), "/").concat(lensId);
    };
    SiteUrls.prototype.lensUsageAnalyticsUrl = function (lensId) {
        return this.fullUrl(this.lensUsageAnalyticsPath(lensId));
    };
    SiteUrls.prototype.lensUsageAnalyticsPath = function (lensId) {
        return this.sitePath(SiteUrls.lensUsageAnalyticsPart(lensId));
    };
    SiteUrls.lensUsageAnalyticsPart = function (lensId) {
        return "".concat(SiteUrls.lensPart(lensId)).concat(SiteUrls.usageAnalyticsPart());
    };
    SiteUrls.usageAnalyticsPart = function () {
        return '/usageAnalytics';
    };
    SiteUrls.prototype.lensLineageUrl = function (lensId) {
        return this.fullUrl(this.lensLineagePath(lensId));
    };
    SiteUrls.prototype.lensLineagePath = function (lensId) {
        return this.sitePath(SiteUrls.lensLineagePart(lensId));
    };
    SiteUrls.lensLineagePart = function (lensId) {
        return "".concat(SiteUrls.lensPart(lensId)).concat(SiteUrls.lineagePart());
    };
    SiteUrls.prototype.lensLineageFieldsUrl = function (lensId) {
        return this.fullUrl(this.lensLineageFieldsPath(lensId));
    };
    SiteUrls.prototype.lensLineageFieldsPath = function (lensId) {
        return this.sitePath(SiteUrls.lensLineageFieldsPart(lensId));
    };
    SiteUrls.lensLineageFieldsPart = function (lensId) {
        return "".concat(SiteUrls.lensLineagePart(lensId)).concat(SiteUrls.fieldsPart());
    };
    SiteUrls.prototype.lensLineageFieldUrl = function (lensId, fieldId) {
        return this.fullUrl(this.lensLineageFieldPath(lensId, fieldId));
    };
    SiteUrls.prototype.lensLineageFieldPath = function (lensId, fieldId) {
        return this.sitePath(SiteUrls.lensLineageFieldPart(lensId, fieldId));
    };
    SiteUrls.lensLineageFieldPart = function (lensId, fieldId) {
        return "".concat(SiteUrls.lensLineagePart(lensId)).concat(SiteUrls.fieldsPart(), "/").concat(fieldId);
    };
    SiteUrls.prototype.lensLineageUpstreamDatabasesUrl = function (lensId) {
        return this.fullUrl(this.lensLineageUpstreamDatabasesPath(lensId));
    };
    SiteUrls.prototype.lensLineageUpstreamDatabasesPath = function (lensId) {
        return this.sitePath(SiteUrls.lensLineageUpstreamDatabasesPart(lensId));
    };
    SiteUrls.lensLineageUpstreamDatabasesPart = function (lensId) {
        return "".concat(SiteUrls.lensLineagePart(lensId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.lensLineageUpstreamTablesUrl = function (lensId) {
        return this.fullUrl(this.lensLineageUpstreamTablesPath(lensId));
    };
    SiteUrls.prototype.lensLineageUpstreamTablesPath = function (lensId) {
        return this.sitePath(SiteUrls.lensLineageUpstreamTablesPart(lensId));
    };
    SiteUrls.lensLineageUpstreamTablesPart = function (lensId) {
        return "".concat(SiteUrls.lensLineagePart(lensId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.lensLineageUpstreamVirtualConnectionsUrl = function (lensId) {
        return this.fullUrl(this.lensLineageUpstreamVirtualConnectionsPath(lensId));
    };
    SiteUrls.prototype.lensLineageUpstreamVirtualConnectionsPath = function (lensId) {
        return this.sitePath(SiteUrls.lensLineageUpstreamVirtualConnectionsPart(lensId));
    };
    SiteUrls.lensLineageUpstreamVirtualConnectionsPart = function (lensId) {
        return "".concat(SiteUrls.lensLineagePart(lensId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.virtualConnectionsPart());
    };
    SiteUrls.prototype.lensLineageUpstreamVirtualConnectionTablesUrl = function (lensId) {
        return this.fullUrl(this.lensLineageUpstreamVirtualConnectionTablesPath(lensId));
    };
    SiteUrls.prototype.lensLineageUpstreamVirtualConnectionTablesPath = function (lensId) {
        return this.sitePath(SiteUrls.lensLineageUpstreamVirtualConnectionTablesPart(lensId));
    };
    SiteUrls.lensLineageUpstreamVirtualConnectionTablesPart = function (lensId) {
        return "".concat(SiteUrls.lensLineagePart(lensId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.virtualConnectionTablesPart());
    };
    SiteUrls.prototype.lensLineageUpstreamFlowsUrl = function (lensId) {
        return this.fullUrl(this.lensLineageUpstreamFlowsPath(lensId));
    };
    SiteUrls.prototype.lensLineageUpstreamFlowsPath = function (lensId) {
        return this.sitePath(SiteUrls.lensLineageUpstreamFlowsPart(lensId));
    };
    SiteUrls.lensLineageUpstreamFlowsPart = function (lensId) {
        return "".concat(SiteUrls.lensLineagePart(lensId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.lensLineageUpstreamDatasourcesUrl = function (lensId) {
        return this.fullUrl(this.lensLineageUpstreamDatasourcesPath(lensId));
    };
    SiteUrls.prototype.lensLineageUpstreamDatasourcesPath = function (lensId) {
        return this.sitePath(SiteUrls.lensLineageUpstreamDatasourcesPart(lensId));
    };
    SiteUrls.lensLineageUpstreamDatasourcesPart = function (lensId) {
        return "".concat(SiteUrls.lensLineagePart(lensId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.lensLineageDownstreamWorkbooksUrl = function (lensId) {
        return this.fullUrl(this.lensLineageDownstreamWorkbooksPath(lensId));
    };
    SiteUrls.prototype.lensLineageDownstreamWorkbooksPath = function (lensId) {
        return this.sitePath(SiteUrls.lensLineageDownstreamWorkbooksPart(lensId));
    };
    SiteUrls.lensLineageDownstreamWorkbooksPart = function (lensId) {
        return "".concat(SiteUrls.lensLineagePart(lensId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.workbooksPart());
    };
    SiteUrls.prototype.lensLineageDownstreamDashboardsUrl = function (lensId) {
        return this.fullUrl(this.lensLineageDownstreamDashboardsPath(lensId));
    };
    SiteUrls.prototype.lensLineageDownstreamDashboardsPath = function (lensId) {
        return this.sitePath(SiteUrls.lensLineageDownstreamDashboardsPart(lensId));
    };
    SiteUrls.lensLineageDownstreamDashboardsPart = function (lensId) {
        return "".concat(SiteUrls.lensLineagePart(lensId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.dashboardsPart());
    };
    SiteUrls.prototype.lensLineageDownstreamMetricsUrl = function (lensId) {
        return this.fullUrl(this.lensLineageDownstreamMetricsPath(lensId));
    };
    SiteUrls.prototype.lensLineageDownstreamMetricsPath = function (lensId) {
        return this.sitePath(SiteUrls.lensLineageDownstreamMetricsPart(lensId));
    };
    SiteUrls.lensLineageDownstreamMetricsPart = function (lensId) {
        return "".concat(SiteUrls.lensLineagePart(lensId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lineageMetricsPart());
    };
    SiteUrls.prototype.lensLineageDownstreamOwnersUrl = function (lensId) {
        return this.fullUrl(this.lensLineageDownstreamOwnersPath(lensId));
    };
    SiteUrls.prototype.lensLineageDownstreamOwnersPath = function (lensId) {
        return this.sitePath(SiteUrls.lensLineageDownstreamOwnersPart(lensId));
    };
    SiteUrls.lensLineageDownstreamOwnersPart = function (lensId) {
        return "".concat(SiteUrls.lensLineagePart(lensId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.ownersPart());
    };
    // Flows
    SiteUrls.prototype.flowsUrl = function () {
        return this.fullUrl(this.flowsPath());
    };
    SiteUrls.prototype.flowsPath = function () {
        return this.sitePath(SiteUrls.flowsPart());
    };
    SiteUrls.flowsPart = function () {
        return '/flows';
    };
    SiteUrls.prototype.flowUrl = function (flowId) {
        return this.fullUrl(this.flowPath(flowId));
    };
    SiteUrls.prototype.flowPath = function (flowId) {
        return this.sitePath(SiteUrls.flowPart(flowId));
    };
    SiteUrls.flowPart = function (flowId) {
        return "".concat(SiteUrls.flowsPart(), "/").concat(flowId);
    };
    // TODO: remove in favor of redirectToFlowUrl?
    SiteUrls.prototype.favoriteFlowUrl = function (flowId) {
        return this.redirectToFlowUrl(flowId);
    };
    SiteUrls.prototype.redirectToFlowUrl = function (flowId) {
        return this.fullUrl(this.redirectToFlowPath(flowId));
    };
    SiteUrls.prototype.redirectToFlowPath = function (flowId) {
        return this.sitePath(SiteUrls.redirectToFlowPart(flowId));
    };
    SiteUrls.redirectToFlowPart = function (flowId) {
        return "/redirect_to_flow/".concat(flowId);
    };
    SiteUrls.prototype.flowsWithTagUrl = function (tag) {
        return this.fullUrl(this.flowsWithTagPath(tag));
    };
    SiteUrls.prototype.flowsWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.flowsWithTagPart(tag));
    };
    SiteUrls.flowsWithTagPart = function (tag) {
        return "".concat(SiteUrls.flowsPart()).concat(SiteUrls.tagPart(tag));
    };
    SiteUrls.tagPart = function (tag) {
        return "?".concat(tagParam(tag));
    };
    SiteUrls.prototype.flowConnectionsUrl = function (flowId) {
        return this.fullUrl(this.flowConnectionsPath(flowId));
    };
    SiteUrls.prototype.flowConnectionsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowConnectionsPart(flowId));
    };
    SiteUrls.flowConnectionsPart = function (flowId) {
        return "".concat(SiteUrls.flowPart(flowId)).concat(SiteUrls.connectionsPart());
    };
    // Used for search url as well
    SiteUrls.connectionsPart = function () {
        return '/connections';
    };
    SiteUrls.prototype.flowOverviewUrl = function (flowId) {
        return this.fullUrl(this.flowOverviewPath(flowId));
    };
    SiteUrls.prototype.flowOverviewPath = function (flowId) {
        return this.sitePath(SiteUrls.flowOverviewPart(flowId));
    };
    SiteUrls.flowOverviewPart = function (flowId) {
        return "".concat(SiteUrls.flowPart(flowId)).concat(SiteUrls.overviewPart());
    };
    SiteUrls.overviewPart = function () {
        return '/overview';
    };
    SiteUrls.prototype.flowRunHistoryUrl = function (flowId) {
        return this.fullUrl(this.flowRunHistoryPath(flowId));
    };
    SiteUrls.prototype.flowRunHistoryPath = function (flowId) {
        return this.sitePath(SiteUrls.flowRunHistoryPart(flowId));
    };
    SiteUrls.flowRunHistoryPart = function (flowId) {
        return "".concat(SiteUrls.flowPart(flowId)).concat(SiteUrls.runHistoryPart());
    };
    SiteUrls.runHistoryPart = function () {
        return '/runHistory';
    };
    SiteUrls.prototype.flowSubscriptionsUrl = function (flowId) {
        return this.fullUrl(this.flowSubscriptionsPath(flowId));
    };
    SiteUrls.prototype.flowSubscriptionsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowSubscriptionsPart(flowId));
    };
    SiteUrls.flowSubscriptionsPart = function (flowId) {
        return "".concat(SiteUrls.flowPart(flowId)).concat(SiteUrls.subscriptionsPart());
    };
    SiteUrls.prototype.flowScheduledTasksUrl = function (flowId) {
        return this.fullUrl(this.flowScheduledTasksPath(flowId));
    };
    SiteUrls.prototype.flowScheduledTasksPath = function (flowId) {
        return this.sitePath(SiteUrls.flowScheduledTasksPart(flowId));
    };
    SiteUrls.flowScheduledTasksPart = function (flowId) {
        return "".concat(SiteUrls.flowPart(flowId)).concat(SiteUrls.scheduledTasksPart());
    };
    SiteUrls.scheduledTasksPart = function () {
        return '/scheduledTasks';
    };
    SiteUrls.prototype.flowLineageUrl = function (flowId) {
        return this.fullUrl(this.flowLineagePath(flowId));
    };
    SiteUrls.prototype.flowLineagePath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineagePart(flowId));
    };
    SiteUrls.flowLineagePart = function (flowId) {
        return "".concat(SiteUrls.flowPart(flowId)).concat(SiteUrls.lineagePart());
    };
    SiteUrls.prototype.flowLineageFieldsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageFieldsPath(flowId));
    };
    SiteUrls.prototype.flowLineageFieldsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageFieldsPart(flowId));
    };
    SiteUrls.flowLineageFieldsPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.fieldsPart());
    };
    SiteUrls.prototype.flowLineageFieldUrl = function (flowId, fieldId) {
        return this.fullUrl(this.flowLineageFieldPath(flowId, fieldId));
    };
    SiteUrls.prototype.flowLineageFieldPath = function (flowId, fieldId) {
        return this.sitePath(SiteUrls.flowLineageFieldPart(flowId, fieldId));
    };
    SiteUrls.flowLineageFieldPart = function (flowId, fieldId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.fieldsPart(), "/").concat(fieldId);
    };
    SiteUrls.prototype.flowLineageUpstreamDatabasesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageUpstreamDatabasesPath(flowId));
    };
    SiteUrls.prototype.flowLineageUpstreamDatabasesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageUpstreamDatabasesPart(flowId));
    };
    SiteUrls.flowLineageUpstreamDatabasesPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.flowLineageUpstreamTablesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageUpstreamTablesPath(flowId));
    };
    SiteUrls.prototype.flowLineageUpstreamTablesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageUpstreamTablesPart(flowId));
    };
    SiteUrls.flowLineageUpstreamTablesPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.flowLineageUpstreamVirtualConnectionsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageUpstreamVirtualConnectionsPath(flowId));
    };
    SiteUrls.prototype.flowLineageUpstreamVirtualConnectionsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageUpstreamVirtualConnectionsPart(flowId));
    };
    SiteUrls.flowLineageUpstreamVirtualConnectionsPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.virtualConnectionsPart());
    };
    SiteUrls.prototype.flowLineageUpstreamVirtualConnectionTablesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageUpstreamVirtualConnectionTablesPath(flowId));
    };
    SiteUrls.prototype.flowLineageUpstreamVirtualConnectionTablesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageUpstreamVirtualConnectionTablesPart(flowId));
    };
    SiteUrls.flowLineageUpstreamVirtualConnectionTablesPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.virtualConnectionTablesPart());
    };
    SiteUrls.prototype.flowLineageUpstreamFlowsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageUpstreamFlowsPath(flowId));
    };
    SiteUrls.prototype.flowLineageUpstreamFlowsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageUpstreamFlowsPart(flowId));
    };
    SiteUrls.flowLineageUpstreamFlowsPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.flowLineageUpstreamDatasourcesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageUpstreamDatasourcesPath(flowId));
    };
    SiteUrls.prototype.flowLineageUpstreamDatasourcesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageUpstreamDatasourcesPart(flowId));
    };
    SiteUrls.flowLineageUpstreamDatasourcesPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.flowLineageDownstreamDatabasesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamDatabasesPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamDatabasesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamDatabasesPart(flowId));
    };
    SiteUrls.flowLineageDownstreamDatabasesPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.flowLineageDownstreamTablesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamTablesPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamTablesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamTablesPart(flowId));
    };
    SiteUrls.flowLineageDownstreamTablesPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.flowLineageDownstreamFlowsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamFlowsPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamFlowsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamFlowsPart(flowId));
    };
    SiteUrls.flowLineageDownstreamFlowsPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.flowLineageDownstreamMetricDefinitionsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamMetricDefinitionsPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamMetricDefinitionsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamMetricDefinitionsPart(flowId));
    };
    SiteUrls.flowLineageDownstreamMetricDefinitionsPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.metricDefinitionsPart());
    };
    SiteUrls.prototype.flowLineageDownstreamDatasourcesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamDatasourcesPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamDatasourcesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamDatasourcesPart(flowId));
    };
    SiteUrls.flowLineageDownstreamDatasourcesPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.flowLineageDownstreamLensesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamLensesPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamLensesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamLensesPart(flowId));
    };
    SiteUrls.flowLineageDownstreamLensesPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lensesPart());
    };
    SiteUrls.prototype.flowLineageDownstreamWorkbooksUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamWorkbooksPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamWorkbooksPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamWorkbooksPart(flowId));
    };
    SiteUrls.flowLineageDownstreamWorkbooksPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.workbooksPart());
    };
    SiteUrls.prototype.flowLineageDownstreamDashboardsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamDashboardsPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamDashboardsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamDashboardsPart(flowId));
    };
    SiteUrls.flowLineageDownstreamDashboardsPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.dashboardsPart());
    };
    SiteUrls.prototype.flowLineageDownstreamSheetsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamSheetsPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamSheetsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamSheetsPart(flowId));
    };
    SiteUrls.flowLineageDownstreamSheetsPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.sheetsPart());
    };
    SiteUrls.prototype.flowLineageDownstreaMetricsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamMetricsPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamMetricsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamMetricsPart(flowId));
    };
    SiteUrls.flowLineageDownstreamMetricsPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lineageMetricsPart());
    };
    SiteUrls.prototype.flowLineageDownstreamOwnersUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamOwnersPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamOwnersPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamOwnersPart(flowId));
    };
    SiteUrls.flowLineageDownstreamOwnersPart = function (flowId) {
        return "".concat(SiteUrls.flowLineagePart(flowId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.ownersPart());
    };
    SiteUrls.prototype.flowPublishresultUrl = function (flowId) {
        return this.fullUrl(this.flowPublishresultPath(flowId));
    };
    SiteUrls.prototype.flowPublishresultPath = function (flowId) {
        return this.sitePath(SiteUrls.flowPublishresultPart(flowId));
    };
    SiteUrls.flowPublishresultPart = function (flowId) {
        return "".concat(SiteUrls.flowPart(flowId)).concat(SiteUrls.publishresultPart());
    };
    // Projects
    SiteUrls.prototype.projectsUrl = function () {
        return this.fullUrl(this.projectsPath());
    };
    SiteUrls.prototype.projectsPath = function () {
        return this.sitePath(SiteUrls.projectsPart());
    };
    SiteUrls.projectsPart = function () {
        return '/projects';
    };
    SiteUrls.prototype.projectUrl = function (projectId) {
        return this.fullUrl(this.projectPath(projectId));
    };
    SiteUrls.prototype.projectPath = function (projectId) {
        return this.sitePath(SiteUrls.projectPart(projectId));
    };
    SiteUrls.projectPart = function (projectId) {
        return "".concat(SiteUrls.projectsPart(), "/").concat(projectId);
    };
    SiteUrls.prototype.projectViewsUrl = function (projectId) {
        return this.fullUrl(this.projectViewsPath(projectId));
    };
    SiteUrls.prototype.projectViewsPath = function (projectId) {
        return this.sitePath(SiteUrls.projectViewsPart(projectId));
    };
    SiteUrls.projectViewsPart = function (projectId) {
        return "".concat(SiteUrls.projectPart(projectId)).concat(SiteUrls.viewsPart());
    };
    // TODO: remove in favor of redirectToProjectUrl?
    SiteUrls.prototype.favoriteProjectUrl = function (projectId) {
        return this.redirectToProjectUrl(projectId);
    };
    SiteUrls.prototype.redirectToProjectUrl = function (projectId) {
        return this.fullUrl(this.redirectToProjectPath(projectId));
    };
    SiteUrls.prototype.redirectToProjectPath = function (projectId) {
        return this.sitePath(SiteUrls.redirectToProjectPart(projectId));
    };
    SiteUrls.redirectToProjectPart = function (projectId) {
        return "/redirect_to_project/".concat(projectId);
    };
    // FlowEditor
    SiteUrls.prototype.flowEditorPath = function () {
        return this.sitePath(SiteUrls.flowEditorPart());
    };
    SiteUrls.prototype.flowEditorDraftUrl = function (draftLuid) {
        return this.flowEditorDraftPath(draftLuid);
    };
    SiteUrls.prototype.flowEditorDraftPath = function (draftLuid) {
        return "".concat(this.flowEditorPath()).concat(SiteUrls.flowEditorDraftPart(draftLuid));
    };
    SiteUrls.prototype.flowEditorFlowPath = function (params) {
        var flowLuid = params.flowLuid, datasourceUrlName = params.datasourceUrlName, graphQLDatabaseId = params.graphQLDatabaseId, graphQLTableId = params.graphQLTableId, projectId = params.projectId;
        return "".concat(this.flowEditorPath()).concat(SiteUrls.flowEditorFlowsPart(), "/").concat(flowLuid).concat(SiteUrls.flowEditorFlowParamPart({
            datasourceUrlName: datasourceUrlName,
            graphQLDatabaseId: graphQLDatabaseId,
            graphQLTableId: graphQLTableId,
            projectId: projectId,
        }));
    };
    SiteUrls.prototype.flowEditorEmbeddingPath = function () {
        return "".concat(this.flowEditorPath(), "/embedding/tableau.prep.embedding.2.latest.js");
    };
    SiteUrls.flowEditorPart = function () {
        return '/flow-editor';
    };
    SiteUrls.flowEditorDraftPart = function (draftLuid) {
        return "/drafts/".concat(draftLuid);
    };
    SiteUrls.flowEditorFlowsPart = function () {
        return '/flows';
    };
    SiteUrls.flowEditorFlowParamPart = function (params) {
        var urlSearchParams = new URLSearchParams();
        if (params.datasourceUrlName) {
            urlSearchParams.set('datasource', params.datasourceUrlName);
        }
        if (params.graphQLDatabaseId) {
            urlSearchParams.set('graphQLDatabaseId', params.graphQLDatabaseId);
        }
        if (params.graphQLTableId) {
            urlSearchParams.set('graphQLTableId', params.graphQLTableId);
        }
        if (params.projectId) {
            urlSearchParams.set('projectId', params.projectId);
        }
        var paramPart = urlSearchParams.toString();
        return paramPart === '' ? paramPart : "?".concat(paramPart);
    };
    // VirtualConnections
    SiteUrls.prototype.virtualConnectionsUrl = function () {
        return this.fullUrl(this.virtualConnectionsPath());
    };
    SiteUrls.prototype.virtualConnectionsPath = function () {
        return this.sitePath(SiteUrls.virtualConnectionsPart());
    };
    SiteUrls.virtualConnectionsPart = function () {
        return '/virtualConnections';
    };
    SiteUrls.prototype.virtualConnectionsWithTagUrl = function (tag) {
        return this.fullUrl(this.virtualConnectionsWithTagPath(tag));
    };
    SiteUrls.prototype.virtualConnectionsWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.virtualConnectionsWithTagPart(tag));
    };
    SiteUrls.virtualConnectionsWithTagPart = function (tag) {
        return "".concat(SiteUrls.virtualConnectionsPart()).concat(SiteUrls.tagPart(tag));
    };
    SiteUrls.prototype.favoriteVirtualConnectionUrl = function (id) {
        return this.redirectToVirtualConnectionUrl(id);
    };
    SiteUrls.prototype.virtualConnectionUrl = function (id) {
        return this.fullUrl(this.virtualConnectionPath(id));
    };
    SiteUrls.prototype.virtualConnectionPath = function (id) {
        return this.sitePath(SiteUrls.virtualConnectionPart(id));
    };
    SiteUrls.virtualConnectionPart = function (id) {
        return "".concat(SiteUrls.virtualConnectionsPart(), "/").concat(id);
    };
    SiteUrls.prototype.redirectToVirtualConnectionUrl = function (id) {
        return this.fullUrl(this.redirectToVirtualConnectionPath(id));
    };
    SiteUrls.prototype.redirectToVirtualConnectionPath = function (id) {
        return this.sitePath(SiteUrls.redirectToVirtualConnectionPart(id));
    };
    SiteUrls.redirectToVirtualConnectionPart = function (id) {
        return "/redirect_to_virtual_connection/".concat(id);
    };
    SiteUrls.prototype.virtualConnectionOverviewUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionOverviewPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionOverviewPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionOverviewPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionOverviewPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionPart(virtualConnectionId)).concat(SiteUrls.overviewPart());
    };
    SiteUrls.prototype.virtualConnectionScheduledTasksUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionScheduledTasksPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionScheduledTasksPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionScheduledTasksPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionScheduledTasksPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionPart(virtualConnectionId)).concat(SiteUrls.scheduledTasksPart());
    };
    SiteUrls.prototype.virtualConnectionLineageUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineagePath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineagePath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineagePart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineagePart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionPart(virtualConnectionId)).concat(SiteUrls.lineagePart());
    };
    SiteUrls.prototype.virtualConnectionLineageVirtualConnectionTablesUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageVirtualConnectionTablesPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageVirtualConnectionTablesPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageVirtualConnectionTablesPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageVirtualConnectionTablesPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.virtualConnectionLineageVirtualConnectionTableUrl = function (virtualConnectionId, virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionLineageVirtualConnectionTablePath(virtualConnectionId, virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionLineageVirtualConnectionTablePath = function (virtualConnectionId, virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageVirtualConnectionTablePart(virtualConnectionId, virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionLineageVirtualConnectionTablePart = function (virtualConnectionId, virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.tablesPart(), "/").concat(virtualConnectionTableId);
    };
    SiteUrls.prototype.virtualConnectionLineageUpstreamDatabasesUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageUpstreamDatabasesPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageUpstreamDatabasesPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageUpstreamDatabasesPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageUpstreamDatabasesPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.virtualConnectionLineageUpstreamTablesUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageUpstreamTablesPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageUpstreamTablesPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageUpstreamTablesPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageUpstreamTablesPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamVirtualConnectionTablesUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageDownstreamVirtualConnectionTablesPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamVirtualConnectionTablesPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageDownstreamVirtualConnectionTablesPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageDownstreamVirtualConnectionTablesPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.virtualConnectionTablesPart());
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamFlowsUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageDownstreamFlowsPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamFlowsPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageDownstreamFlowsPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageDownstreamFlowsPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamMetricDefinitionsUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageDownstreamMetricDefinitionsPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamMetricDefinitionsPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageDownstreamMetricDefinitionsPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageDownstreamMetricDefinitionsPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.metricDefinitionsPart());
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamDatasourcesUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageDownstreamDatasourcesPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamDatasourcesPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageDownstreamDatasourcesPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageDownstreamDatasourcesPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamLensesUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageDownstreamLensesPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamLensesPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageDownstreamLensesPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageDownstreamLensesPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lensesPart());
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamWorkbooksUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageDownstreamWorkbooksPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamWorkbooksPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageDownstreamWorkbooksPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageDownstreamWorkbooksPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.workbooksPart());
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamDashboardsUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageDownstreamDashboardsPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamDashboardsPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageDownstreamDashboardsPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageDownstreamDashboardsPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.dashboardsPart());
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamSheetsUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageDownstreamSheetsPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamSheetsPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageDownstreamSheetsPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageDownstreamSheetsPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.sheetsPart());
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamMetricsUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageDownstreamMetricsPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamMetricsPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageDownstreamMetricsPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageDownstreamMetricsPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lineageMetricsPart());
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamOwnersUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionLineageDownstreamOwnersPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionLineageDownstreamOwnersPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionLineageDownstreamOwnersPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionLineageDownstreamOwnersPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionLineagePart(virtualConnectionId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.ownersPart());
    };
    SiteUrls.prototype.virtualConnectionRunHistoryUrl = function (virtualConnectionId) {
        return this.fullUrl(this.virtualConnectionRunHistoryPath(virtualConnectionId));
    };
    SiteUrls.prototype.virtualConnectionRunHistoryPath = function (virtualConnectionId) {
        return this.sitePath(SiteUrls.virtualConnectionRunHistoryPart(virtualConnectionId));
    };
    SiteUrls.virtualConnectionRunHistoryPart = function (virtualConnectionId) {
        return "".concat(SiteUrls.virtualConnectionPart(virtualConnectionId)).concat(SiteUrls.runHistoryPart());
    };
    // VirtualConnectionTables
    SiteUrls.prototype.virtualConnectionTablesUrl = function () {
        return this.fullUrl(this.virtualConnectionTablesPath());
    };
    SiteUrls.prototype.virtualConnectionTablesPath = function () {
        return this.sitePath(SiteUrls.virtualConnectionTablesPart());
    };
    SiteUrls.virtualConnectionTablesPart = function () {
        return '/virtualConnectionTables';
    };
    SiteUrls.prototype.virtualConnectionTablesWithTagUrl = function (tag) {
        return this.fullUrl(this.virtualConnectionTablesWithTagPath(tag));
    };
    SiteUrls.prototype.virtualConnectionTablesWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.virtualConnectionTablesWithTagPart(tag));
    };
    SiteUrls.virtualConnectionTablesWithTagPart = function (tag) {
        return "".concat(SiteUrls.virtualConnectionTablesPart()).concat(SiteUrls.tagPart(tag));
    };
    SiteUrls.prototype.favoriteVirtualConnectionTableUrl = function (id) {
        return this.redirectToVirtualConnectionTableUrl(id);
    };
    SiteUrls.prototype.virtualConnectionTableUrl = function (id) {
        return this.fullUrl(this.virtualConnectionTablePath(id));
    };
    SiteUrls.prototype.virtualConnectionTablePath = function (id) {
        return this.sitePath(SiteUrls.virtualConnectionTablePart(id));
    };
    SiteUrls.virtualConnectionTablePart = function (id) {
        return "".concat(SiteUrls.virtualConnectionTablesPart(), "/").concat(id);
    };
    SiteUrls.prototype.redirectToVirtualConnectionTableUrl = function (id) {
        return this.fullUrl(this.redirectToVirtualConnectionTablePath(id));
    };
    SiteUrls.prototype.redirectToVirtualConnectionTablePath = function (id) {
        return this.sitePath(SiteUrls.redirectToVirtualConnectionTablePart(id));
    };
    SiteUrls.redirectToVirtualConnectionTablePart = function (id) {
        return "/redirect_to_virtual_connection_table/".concat(id);
    };
    SiteUrls.prototype.virtualConnectionTableOverviewUrl = function (id) {
        return this.fullUrl(this.virtualConnectionTableOverviewPath(id));
    };
    SiteUrls.prototype.virtualConnectionTableOverviewPath = function (id) {
        return this.sitePath(SiteUrls.virtualConnectionTableOverviewPart(id));
    };
    SiteUrls.virtualConnectionTableOverviewPart = function (id) {
        return "".concat(SiteUrls.virtualConnectionTablePart(id)).concat(SiteUrls.overviewPart());
    };
    SiteUrls.prototype.virtualConnectionTableScheduledTasksUrl = function (id) {
        return this.fullUrl(this.virtualConnectionTableScheduledTasksPath(id));
    };
    SiteUrls.prototype.virtualConnectionTableScheduledTasksPath = function (id) {
        return this.sitePath(SiteUrls.virtualConnectionTableScheduledTasksPart(id));
    };
    SiteUrls.virtualConnectionTableScheduledTasksPart = function (id) {
        return "".concat(SiteUrls.virtualConnectionTablePart(id)).concat(SiteUrls.scheduledTasksPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineagePath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineagePath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineagePart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTablePart(virtualConnectionTableId)).concat(SiteUrls.lineagePart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageFieldsUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageFieldsPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageFieldsPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageFieldsPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageFieldsPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.fieldsPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageFieldUrl = function (virtualConnectionTableId, fieldId) {
        return this.fullUrl(this.virtualConnectionTableLineageFieldPath(virtualConnectionTableId, fieldId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageFieldPath = function (virtualConnectionTableId, fieldId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageFieldPart(virtualConnectionTableId, fieldId));
    };
    SiteUrls.virtualConnectionTableLineageFieldPart = function (virtualConnectionTableId, fieldId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.fieldsPart(), "/").concat(fieldId);
    };
    SiteUrls.prototype.virtualConnectionTableLineageUpstreamDatabasesUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageUpstreamDatabasesPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageUpstreamDatabasesPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageUpstreamDatabasesPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageUpstreamDatabasesPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageUpstreamTablesUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageUpstreamTablesPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageUpstreamTablesPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageUpstreamTablesPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageUpstreamTablesPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageUpstreamVirtualConnectionsUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageUpstreamVirtualConnectionsPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageUpstreamVirtualConnectionsPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageUpstreamVirtualConnectionsPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageUpstreamVirtualConnectionsPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.virtualConnectionsPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamFlowsUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageDownstreamFlowsPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamFlowsPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageDownstreamFlowsPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageDownstreamFlowsPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamMetricDefinitionsUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageDownstreamMetricDefinitionsPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamMetricDefinitionsPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageDownstreamMetricDefinitionsPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageDownstreamMetricDefinitionsPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.metricDefinitionsPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamDatasourcesUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageDownstreamDatasourcesPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamDatasourcesPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageDownstreamDatasourcesPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageDownstreamDatasourcesPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamLensesUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageDownstreamLensesPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamLensesPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageDownstreamLensesPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageDownstreamLensesPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lensesPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamWorkbooksUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageDownstreamWorkbooksPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamWorkbooksPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageDownstreamWorkbooksPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageDownstreamWorkbooksPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.workbooksPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamDashboardsUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageDownstreamDashboardsPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamDashboardsPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageDownstreamDashboardsPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageDownstreamDashboardsPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.dashboardsPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamSheetsUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageDownstreamSheetsPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamSheetsPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageDownstreamSheetsPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageDownstreamSheetsPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.sheetsPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamMetricsUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageDownstreamMetricsPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamMetricsPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageDownstreamMetricsPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageDownstreamMetricsPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lineageMetricsPart());
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamOwnersUrl = function (virtualConnectionTableId) {
        return this.fullUrl(this.virtualConnectionTableLineageDownstreamOwnersPath(virtualConnectionTableId));
    };
    SiteUrls.prototype.virtualConnectionTableLineageDownstreamOwnersPath = function (virtualConnectionTableId) {
        return this.sitePath(SiteUrls.virtualConnectionTableLineageDownstreamOwnersPart(virtualConnectionTableId));
    };
    SiteUrls.virtualConnectionTableLineageDownstreamOwnersPart = function (virtualConnectionTableId) {
        return "".concat(SiteUrls.virtualConnectionTableLineagePart(virtualConnectionTableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.ownersPart());
    };
    // Workbooks
    SiteUrls.prototype.workbooksUrl = function () {
        return this.fullUrl(this.workbooksPath());
    };
    SiteUrls.prototype.workbooksPath = function () {
        return this.sitePath(SiteUrls.workbooksPart());
    };
    SiteUrls.workbooksPart = function () {
        return '/workbooks';
    };
    SiteUrls.prototype.workbooksWithTagUrl = function (tag) {
        return this.fullUrl(this.workbooksWithTagPath(tag));
    };
    SiteUrls.prototype.workbooksWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.workbooksWithTagPart(tag));
    };
    SiteUrls.workbooksWithTagPart = function (tag) {
        return "".concat(SiteUrls.workbooksPart()).concat(SiteUrls.tagPart(tag));
    };
    SiteUrls.prototype.workbookUrl = function (workbookId) {
        return this.fullUrl(this.workbookPath(workbookId));
    };
    SiteUrls.prototype.workbookPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookPart(workbookId));
    };
    SiteUrls.workbookPart = function (workbookId) {
        return "".concat(SiteUrls.workbooksPart(), "/").concat(workbookId);
    };
    SiteUrls.prototype.workbookViewsUrl = function (workbookId) {
        return this.fullUrl(this.workbookViewsPath(workbookId));
    };
    SiteUrls.prototype.workbookViewsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookViewsPart(workbookId));
    };
    SiteUrls.workbookViewsPart = function (workbookId) {
        return "".concat(SiteUrls.workbookPart(workbookId)).concat(SiteUrls.viewsPart());
    };
    SiteUrls.prototype.workbookCustomViewsUrl = function (workbookId) {
        return this.fullUrl(this.workbookCustomViewsPath(workbookId));
    };
    SiteUrls.prototype.workbookCustomViewsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookCustomViewsPart(workbookId));
    };
    SiteUrls.workbookCustomViewsPart = function (workbookId) {
        return "".concat(SiteUrls.workbookPart(workbookId)).concat(SiteUrls.customViewsPart());
    };
    SiteUrls.prototype.workbookSubscriptionsUrl = function (workbookId) {
        return this.fullUrl(this.workbookSubscriptionsPath(workbookId));
    };
    SiteUrls.prototype.workbookSubscriptionsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookSubscriptionsPart(workbookId));
    };
    SiteUrls.workbookSubscriptionsPart = function (workbookId) {
        return "".concat(SiteUrls.workbookPart(workbookId)).concat(SiteUrls.subscriptionsPart());
    };
    SiteUrls.prototype.workbookExtractRefreshesUrl = function (workbookId) {
        return this.fullUrl(this.workbookExtractRefreshesPath(workbookId));
    };
    SiteUrls.prototype.workbookExtractRefreshesPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookExtractRefreshesPart(workbookId));
    };
    SiteUrls.workbookExtractRefreshesPart = function (workbookId) {
        return "".concat(SiteUrls.workbookPart(workbookId)).concat(SiteUrls.extractRefreshesPart());
    };
    SiteUrls.prototype.workbookDetailsUrl = function (workbookId) {
        return this.fullUrl(this.workbookDetailsPath(workbookId));
    };
    SiteUrls.prototype.workbookDetailsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookDetailsPart(workbookId));
    };
    SiteUrls.workbookDetailsPart = function (workbookId) {
        return "".concat(SiteUrls.workbookPart(workbookId)).concat(SiteUrls.detailsPart());
    };
    SiteUrls.prototype.workbookPublishresultUrl = function (workbookId) {
        return this.fullUrl(this.workbookPublishresultPath(workbookId));
    };
    SiteUrls.prototype.workbookPublishresultPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookPublishresultPart(workbookId));
    };
    SiteUrls.workbookPublishresultPart = function (workbookId) {
        return "".concat(SiteUrls.workbookPart(workbookId)).concat(SiteUrls.publishresultPart());
    };
    SiteUrls.publishresultPart = function () {
        return '/publishresult';
    };
    SiteUrls.prototype.workbookDatasourcesUrl = function (workbookId) {
        return this.fullUrl(this.workbookDatasourcesPath(workbookId));
    };
    SiteUrls.prototype.workbookDatasourcesPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookDatasourcesPart(workbookId));
    };
    SiteUrls.workbookDatasourcesPart = function (workbookId) {
        return "".concat(SiteUrls.workbookPart(workbookId)).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.workbookConnectedMetricsUrl = function (workbookId) {
        return this.fullUrl(this.workbookConnectedMetricsPath(workbookId));
    };
    SiteUrls.prototype.workbookConnectedMetricsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookConnectedMetricsPart(workbookId));
    };
    SiteUrls.workbookConnectedMetricsPart = function (workbookId) {
        return "".concat(SiteUrls.workbookPart(workbookId)).concat(SiteUrls.connectedMetricsPart());
    };
    SiteUrls.connectedMetricsPart = function () {
        return '/connectedMetrics';
    };
    // TODO: remove in favor of redirectToWorkbookUrl?
    SiteUrls.prototype.favoriteWorkbookUrl = function (workbookId) {
        return this.redirectToWorkbookUrl(workbookId);
    };
    SiteUrls.prototype.redirectToWorkbookUrl = function (workbookId) {
        return this.fullUrl(this.redirectToWorkbookPath(workbookId));
    };
    SiteUrls.prototype.redirectToWorkbookPath = function (workbookId) {
        return this.sitePath(SiteUrls.redirectToWorkbookPart(workbookId));
    };
    SiteUrls.redirectToWorkbookPart = function (workbookId) {
        return "/redirect_to_workbook/".concat(workbookId);
    };
    SiteUrls.prototype.workbookRevisionPreviewUrl = function (revisionPath) {
        return this.fullUrl(this.workbookRevisionPreviewPath(revisionPath));
    };
    SiteUrls.prototype.workbookRevisionPreviewPath = function (revisionPath) {
        return this.sitePath(SiteUrls.workbookRevisionPreviewPart(revisionPath));
    };
    SiteUrls.workbookRevisionPreviewPart = function (revisionPath) {
        return "/".concat(revisionPath);
    };
    SiteUrls.prototype.workbookLineageUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineagePath(workbookId));
    };
    SiteUrls.prototype.workbookLineagePath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineagePart(workbookId));
    };
    SiteUrls.workbookLineagePart = function (workbookId) {
        return "".concat(SiteUrls.workbookPart(workbookId)).concat(SiteUrls.lineagePart());
    };
    SiteUrls.prototype.workbookLineageFieldsUrl = function (workbookId, embeddedDatasourceId) {
        return this.fullUrl(this.workbookLineageFieldsPath(workbookId, embeddedDatasourceId));
    };
    SiteUrls.prototype.workbookLineageFieldsPath = function (workbookId, embeddedDatasourceId) {
        return this.sitePath(SiteUrls.workbookLineageFieldsPart(workbookId, embeddedDatasourceId));
    };
    SiteUrls.workbookLineageFieldsPart = function (workbookId, embeddedDatasourceId) {
        var workbookLineagePart = SiteUrls.workbookLineagePart(workbookId);
        var fieldsPart = SiteUrls.fieldsPart();
        var embeddedDatasourceParamPart = this.workbookLineageEmbeddedDatasourceParamPart(embeddedDatasourceId);
        return "".concat(workbookLineagePart).concat(fieldsPart).concat(embeddedDatasourceParamPart);
    };
    SiteUrls.workbookLineageEmbeddedDatasourceParamPart = function (embeddedDatasourceId) {
        return embeddedDatasourceId === undefined
            ? ''
            : "?".concat(CatalogUrlParamKeys.embeddedDataSource, "=").concat(embeddedDatasourceId);
    };
    SiteUrls.prototype.workbookLineageFieldUrl = function (workbookId, fieldId) {
        return this.fullUrl(this.workbookLineageFieldPath(workbookId, fieldId));
    };
    SiteUrls.prototype.workbookLineageFieldPath = function (workbookId, fieldId) {
        return this.sitePath(SiteUrls.workbookLineageFieldPart(workbookId, fieldId));
    };
    SiteUrls.workbookLineageFieldPart = function (workbookId, fieldId) {
        return "".concat(SiteUrls.workbookLineagePart(workbookId)).concat(SiteUrls.fieldsPart(), "/").concat(fieldId);
    };
    SiteUrls.prototype.workbookLineageUpstreamDatabasesUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageUpstreamDatabasesPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageUpstreamDatabasesPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageUpstreamDatabasesPart(workbookId));
    };
    SiteUrls.workbookLineageUpstreamDatabasesPart = function (workbookId) {
        return "".concat(SiteUrls.workbookLineagePart(workbookId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.workbookLineageUpstreamTablesUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageUpstreamTablesPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageUpstreamTablesPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageUpstreamTablesPart(workbookId));
    };
    SiteUrls.workbookLineageUpstreamTablesPart = function (workbookId) {
        return "".concat(SiteUrls.workbookLineagePart(workbookId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.workbookLineageUpstreamVirtualConnectionsUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageUpstreamVirtualConnectionsPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageUpstreamVirtualConnectionsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageUpstreamVirtualConnectionsPart(workbookId));
    };
    SiteUrls.workbookLineageUpstreamVirtualConnectionsPart = function (workbookId) {
        return "".concat(SiteUrls.workbookLineagePart(workbookId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.virtualConnectionsPart());
    };
    SiteUrls.prototype.workbookLineageUpstreamVirtualConnectionTablesUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageUpstreamVirtualConnectionTablesPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageUpstreamVirtualConnectionTablesPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageUpstreamVirtualConnectionTablesPart(workbookId));
    };
    SiteUrls.workbookLineageUpstreamVirtualConnectionTablesPart = function (workbookId) {
        return "".concat(SiteUrls.workbookLineagePart(workbookId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.virtualConnectionTablesPart());
    };
    SiteUrls.prototype.workbookLineageUpstreamFlowsUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageUpstreamFlowsPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageUpstreamFlowsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageUpstreamFlowsPart(workbookId));
    };
    SiteUrls.workbookLineageUpstreamFlowsPart = function (workbookId) {
        return "".concat(SiteUrls.workbookLineagePart(workbookId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.workbookLineageUpstreamDatasourcesUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageUpstreamDatasourcesPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageUpstreamDatasourcesPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageUpstreamDatasourcesPart(workbookId));
    };
    SiteUrls.workbookLineageUpstreamDatasourcesPart = function (workbookId) {
        return "".concat(SiteUrls.workbookLineagePart(workbookId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.workbookLineageUpstreamLensesUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageUpstreamLensesPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageUpstreamLensesPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageUpstreamLensesPart(workbookId));
    };
    SiteUrls.workbookLineageUpstreamLensesPart = function (workbookId) {
        return "".concat(SiteUrls.workbookLineagePart(workbookId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.lensesPart());
    };
    SiteUrls.prototype.workbookLineageDownstreamDashboardsUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageDownstreamDashboardsPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageDownstreamDashboardsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageDownstreamDashboardsPart(workbookId));
    };
    SiteUrls.workbookLineageDownstreamDashboardsPart = function (workbookId) {
        return "".concat(SiteUrls.workbookLineagePart(workbookId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.dashboardsPart());
    };
    SiteUrls.prototype.workbookLineageDownstreamSheetsUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageDownstreamSheetsPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageDownstreamSheetsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageDownstreamSheetsPart(workbookId));
    };
    SiteUrls.workbookLineageDownstreamSheetsPart = function (workbookId) {
        return "".concat(SiteUrls.workbookLineagePart(workbookId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.sheetsPart());
    };
    SiteUrls.prototype.workbookLineageDownstreamMetricsUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageDownstreamMetricsPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageDownstreamMetricsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageDownstreamMetricsPart(workbookId));
    };
    SiteUrls.workbookLineageDownstreamMetricsPart = function (workbookId) {
        return "".concat(SiteUrls.workbookLineagePart(workbookId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lineageMetricsPart());
    };
    SiteUrls.prototype.workbookLineageDownstreamOwnersUrl = function (tableId) {
        return this.fullUrl(this.workbookLineageDownstreamOwnersPath(tableId));
    };
    SiteUrls.prototype.workbookLineageDownstreamOwnersPath = function (tableId) {
        return this.sitePath(SiteUrls.workbookLineageDownstreamOwnersPart(tableId));
    };
    SiteUrls.workbookLineageDownstreamOwnersPart = function (tableId) {
        return "".concat(SiteUrls.workbookLineagePart(tableId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.ownersPart());
    };
    SiteUrls.prototype.workbookUsageUrl = function (workbookId) {
        return this.fullUrl(this.workbookUsagePath(workbookId));
    };
    SiteUrls.prototype.workbookUsagePath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookUsagePart(workbookId));
    };
    SiteUrls.workbookUsagePart = function (workbookId) {
        return "".concat(SiteUrls.workbookPart(workbookId)).concat(SiteUrls.usagePart());
    };
    SiteUrls.usagePart = function () {
        return '/usage';
    };
    SiteUrls.prototype.workbookUsageMetricUrl = function (params) {
        return this.fullUrl(this.workbookUsageMetricPath(params));
    };
    SiteUrls.prototype.workbookUsageMetricPath = function (params) {
        return this.sitePath(SiteUrls.workbookUsageMetricPart(params));
    };
    SiteUrls.workbookUsageMetricPart = function (params) {
        return "".concat(SiteUrls.workbookUsagePart(params.workbookId), "/").concat(params.usageMetricId);
    };
    // Views
    SiteUrls.prototype.viewsUrl = function () {
        return this.fullUrl(this.viewsPath());
    };
    SiteUrls.prototype.viewsPath = function () {
        return this.sitePath(SiteUrls.viewsPart());
    };
    SiteUrls.viewsPart = function () {
        return '/views';
    };
    SiteUrls.prototype.viewUrl = function (viewPath) {
        return this.fullUrl(this.viewPath(viewPath));
    };
    SiteUrls.prototype.viewPath = function (viewPath) {
        return this.sitePath(SiteUrls.viewPart(viewPath));
    };
    SiteUrls.viewPart = function (viewPath) {
        return "".concat(SiteUrls.viewsPart(), "/").concat(viewPath);
    };
    // TODO: remove this in favor of separate 'addParams' helper?
    SiteUrls.prototype.viewWithDeviceTypeUrl = function (viewPath, deviceType) {
        var urlBase = this.viewUrl(viewPath);
        if (deviceType === 'default') {
            return urlBase;
        }
        return urlBase + '?' + deviceTypeParam(deviceType);
    };
    SiteUrls.prototype.redirectToFavoriteViewUrl = function (viewId) {
        return this.fullUrl(this.redirectToFavoriteViewPath(viewId));
    };
    SiteUrls.prototype.redirectToFavoriteViewPath = function (viewId) {
        return this.sitePath(SiteUrls.redirectToFavoriteViewPart(viewId));
    };
    SiteUrls.redirectToFavoriteViewPart = function (viewId) {
        return "/redirect_to_favorite_view/".concat(viewId);
    };
    SiteUrls.prototype.redirectToViewUrl = function (viewId) {
        return this.fullUrl(this.redirectToViewPath(viewId));
    };
    SiteUrls.prototype.redirectToViewPath = function (viewId) {
        return this.sitePath(SiteUrls.redirectToViewPart(viewId));
    };
    SiteUrls.redirectToViewPart = function (viewId) {
        return "/redirect_to_view/".concat(viewId);
    };
    SiteUrls.prototype.redirectToCustomViewUrlWithLuid = function (viewId, customViewLuid, customViewName) {
        return this.fullUrl(this.redirectToCustomViewPathWithLuid(viewId, customViewLuid, customViewName));
    };
    SiteUrls.prototype.redirectToCustomViewPathWithLuid = function (viewId, customViewLuid, customViewName) {
        return this.sitePath(SiteUrls.redirectToCustomViewPartWithLuid(viewId, customViewLuid, customViewName));
    };
    SiteUrls.redirectToCustomViewPartWithLuid = function (viewId, customViewLuid, customViewName) {
        return "/redirect_to_custom_view/".concat(viewId, "/").concat(customViewLuid, "/").concat(customViewName);
    };
    // Viz recommendations
    // As of Dec 2018, this end-point will be only internally accessable (alpo-dev) and
    // protected by feature flag 'recommendations.viz_recommendations_enabled'
    SiteUrls.prototype.recommendationListUrl = function () {
        return this.fullUrl(this.recommendationListPath());
    };
    SiteUrls.prototype.recommendationListPath = function () {
        return this.sitePath(SiteUrls.recommendationListPart());
    };
    SiteUrls.recommendationListPart = function () {
        return '/recommendations';
    };
    SiteUrls.prototype.recommendationUrl = function (vizId) {
        return this.fullUrl(this.recommendationPath(vizId));
    };
    SiteUrls.prototype.recommendationPath = function (vizId) {
        return this.sitePath(SiteUrls.recommendationPart(vizId));
    };
    SiteUrls.recommendationPart = function (vizId) {
        return "".concat(SiteUrls.recommendationListPart(), "/").concat(vizId);
    };
    // Users
    SiteUrls.prototype.usersUrl = function () {
        return this.fullUrl(this.usersPath());
    };
    SiteUrls.prototype.usersPath = function () {
        return this.sitePath(SiteUrls.usersPart());
    };
    SiteUrls.usersPart = function () {
        return '/users';
    };
    // While the user identity migration is in process, we move the users space into the users/list subspace.
    SiteUrls.prototype.allUsersListUrl = function () {
        return this.fullUrl(this.allUsersListPath());
    };
    SiteUrls.prototype.allUsersListPath = function () {
        return this.usersPath() + SiteUrls.allUsersListPart();
    };
    SiteUrls.allUsersListPart = function () {
        return '/list';
    };
    // While the user identity migration is in process, we have an identity subspace for users.
    SiteUrls.prototype.allUserIdentitiesUrl = function () {
        return this.fullUrl(this.allUserIdentitiesPath());
    };
    SiteUrls.prototype.allUserIdentitiesPath = function () {
        return this.usersPath() + SiteUrls.allUserIdentitiesPart();
    };
    SiteUrls.allUserIdentitiesPart = function () {
        return '/identities';
    };
    SiteUrls.prototype.baseUserUrl = function () {
        return this.fullUrl(this.baseUserPath());
    };
    SiteUrls.prototype.baseUserPath = function () {
        return this.sitePath(SiteUrls.baseUserPart());
    };
    SiteUrls.baseUserPart = function () {
        return "/user";
    };
    SiteUrls.prototype.userUrl = function (username, domainName) {
        return this.fullUrl(this.userPath(username, domainName));
    };
    SiteUrls.prototype.userPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userPart(username, domainName));
    };
    SiteUrls.userPart = function (username, domainName) {
        return (0, util_1.encodePath)("/user/".concat(domainName, "/").concat(username));
    };
    SiteUrls.prototype.userContentUrl = function (username, domainName) {
        return this.fullUrl(this.userContentPath(username, domainName));
    };
    SiteUrls.prototype.userContentPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userContentPart(username, domainName));
    };
    SiteUrls.userContentPart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.contentPart());
    };
    SiteUrls.contentPart = function () {
        return '/content';
    };
    SiteUrls.prototype.userCustomViewsUrl = function (username, domainName) {
        return this.fullUrl(this.userCustomViewsPath(username, domainName));
    };
    SiteUrls.prototype.userCustomViewsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userCustomViewsPart(username, domainName));
    };
    SiteUrls.userCustomViewsPart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.customViewsPart());
    };
    SiteUrls.customViewsPart = function () {
        return '/customViews';
    };
    SiteUrls.prototype.userDataAlertsUrl = function (username, domainName) {
        return this.fullUrl(this.userDataAlertsPath(username, domainName));
    };
    SiteUrls.prototype.userDataAlertsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userDataAlertsPart(username, domainName));
    };
    SiteUrls.userDataAlertsPart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.dataAlertsPart());
    };
    SiteUrls.dataAlertsPart = function () {
        return '/dataAlerts';
    };
    SiteUrls.prototype.userSubscriptionsUrl = function (username, domainName) {
        return this.fullUrl(this.userSubscriptionsPath(username, domainName));
    };
    SiteUrls.prototype.userSubscriptionsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userSubscriptionsPart(username, domainName));
    };
    SiteUrls.userSubscriptionsPart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.subscriptionsPart());
    };
    SiteUrls.prototype.userCollectionsUrl = function (username, domainName) {
        return this.fullUrl(this.userCollectionsPath(username, domainName));
    };
    SiteUrls.prototype.userCollectionsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userCollectionsPart(username, domainName));
    };
    SiteUrls.userCollectionsPart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.collectionsPath());
    };
    SiteUrls.prototype.userPerformanceUrl = function (username, domainName) {
        return this.fullUrl(this.userPerformancePath(username, domainName));
    };
    SiteUrls.prototype.userPerformancePath = function (username, domainName) {
        return this.sitePath(SiteUrls.userPerformancePart(username, domainName));
    };
    SiteUrls.userPerformancePart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.performancePath());
    };
    SiteUrls.prototype.userSettingsUrl = function (username, domainName) {
        return this.fullUrl(this.userSettingsPath(username, domainName));
    };
    SiteUrls.prototype.userSettingsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userSettingsPart(username, domainName));
    };
    SiteUrls.userSettingsPart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.settingsPart());
    };
    // Legacy support user urls: projects, workbooks, views, metrics, datasources. flows
    // for supporting previously bookmarked urls. no new user subspaces should be added here
    SiteUrls.prototype.userProjectsUrl = function (username, domainName) {
        return this.fullUrl(this.userProjectsPath(username, domainName));
    };
    SiteUrls.prototype.userProjectsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userProjectsPart(username, domainName));
    };
    SiteUrls.userProjectsPart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.projectsPart());
    };
    SiteUrls.prototype.userWorkbooksUrl = function (username, domainName) {
        return this.fullUrl(this.userWorkbooksPath(username, domainName));
    };
    SiteUrls.prototype.userWorkbooksPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userWorkbooksPart(username, domainName));
    };
    SiteUrls.userWorkbooksPart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.workbooksPart());
    };
    SiteUrls.prototype.userViewsUrl = function (username, domainName) {
        return this.fullUrl(this.userViewsPath(username, domainName));
    };
    SiteUrls.prototype.userViewsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userViewsPart(username, domainName));
    };
    SiteUrls.userViewsPart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.viewsPart());
    };
    SiteUrls.prototype.userMetricsUrl = function (username, domainName) {
        return this.fullUrl(this.userMetricsPath(username, domainName));
    };
    SiteUrls.prototype.userMetricsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userMetricsPart(username, domainName));
    };
    SiteUrls.userMetricsPart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.metricsPart());
    };
    SiteUrls.prototype.userDatasourcesUrl = function (username, domainName) {
        return this.fullUrl(this.userDatasourcesPath(username, domainName));
    };
    SiteUrls.prototype.userDatasourcesPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userDatasourcesPart(username, domainName));
    };
    SiteUrls.userDatasourcesPart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.userFlowsUrl = function (username, domainName) {
        return this.fullUrl(this.userFlowsPath(username, domainName));
    };
    SiteUrls.prototype.userFlowsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userFlowsPart(username, domainName));
    };
    SiteUrls.userFlowsPart = function (username, domainName) {
        return "".concat(SiteUrls.userPart(username, domainName)).concat(SiteUrls.flowsPart());
    };
    // Data Sources
    SiteUrls.prototype.datasourcesUrl = function () {
        return this.fullUrl(this.datasourcesPath());
    };
    SiteUrls.prototype.datasourcesPath = function () {
        return this.sitePath(SiteUrls.datasourcesPart());
    };
    SiteUrls.datasourcesPart = function () {
        return '/datasources';
    };
    SiteUrls.prototype.datasourcesWithTagUrl = function (tag) {
        return this.fullUrl(this.datasourcesWithTagPath(tag));
    };
    SiteUrls.prototype.datasourcesWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.datasourcesWithTagPart(tag));
    };
    SiteUrls.datasourcesWithTagPart = function (tag) {
        return "".concat(SiteUrls.datasourcesPart()).concat(SiteUrls.tagPart(tag));
    };
    SiteUrls.prototype.datasourceUrl = function (datasourceId) {
        return this.fullUrl(this.datasourcePath(datasourceId));
    };
    SiteUrls.prototype.datasourcePath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourcePart(datasourceId));
    };
    SiteUrls.datasourcePart = function (datasourceId) {
        return "".concat(SiteUrls.datasourcesPart(), "/").concat(datasourceId);
    };
    SiteUrls.prototype.exploreDatasourceUrl = function (datasourceId) {
        return this.fullUrl(this.exploreDatasourcePath(datasourceId));
    };
    SiteUrls.prototype.exploreDatasourcePath = function (datasourceId) {
        return this.sitePath(SiteUrls.exploreDatasourcePart(datasourceId));
    };
    SiteUrls.exploreDatasourcePart = function (datasourceId) {
        return "/explore/datasource/".concat(datasourceId);
    };
    SiteUrls.prototype.datasourcePublishresultUrl = function (datasourceId) {
        return this.fullUrl(this.datasourcePublishresultPath(datasourceId));
    };
    SiteUrls.prototype.datasourcePublishresultPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourcePublishresultPart(datasourceId));
    };
    SiteUrls.datasourcePublishresultPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourcePart(datasourceId)).concat(SiteUrls.publishresultPart());
    };
    SiteUrls.prototype.datasourceAskDataUsageAnalyticsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceAskDataUsageAnalyticsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceAskDataUsageAnalyticsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceAskDataUsageAnalyticsPart(datasourceId));
    };
    SiteUrls.datasourceAskDataUsageAnalyticsPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourcePart(datasourceId)).concat(SiteUrls.askDataUsageAnalyticsPart());
    };
    SiteUrls.askDataUsageAnalyticsPart = function () {
        return '/askDataUsageAnalytics';
    };
    SiteUrls.prototype.datasourceAskDataUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceAskDataPath(datasourceId));
    };
    SiteUrls.prototype.datasourceAskDataPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceAskDataPart(datasourceId));
    };
    SiteUrls.datasourceAskDataPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourcePart(datasourceId)).concat(SiteUrls.askDataPart());
    };
    SiteUrls.askDataPart = function () {
        return '/askData';
    };
    SiteUrls.prototype.datasourceConnectionsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceConnectionsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceConnectionsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceConnectionsPart(datasourceId));
    };
    SiteUrls.datasourceConnectionsPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourcePart(datasourceId)).concat(SiteUrls.connectionsPart());
    };
    SiteUrls.prototype.datasourceExtractRefreshesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceExtractRefreshesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceExtractRefreshesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceExtractRefreshesPart(datasourceId));
    };
    SiteUrls.datasourceExtractRefreshesPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourcePart(datasourceId)).concat(SiteUrls.extractRefreshesPart());
    };
    SiteUrls.prototype.datasourceLocalExtractRefreshesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLocalExtractRefreshesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLocalExtractRefreshesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLocalExtractRefreshesPart(datasourceId));
    };
    SiteUrls.datasourceLocalExtractRefreshesPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourcePart(datasourceId)).concat(SiteUrls.localExtractRefreshesPart());
    };
    SiteUrls.localExtractRefreshesPart = function () {
        return '/localExtractRefreshes';
    };
    SiteUrls.prototype.datasourceConnectedWorkbooksUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceConnectedWorkbooksPath(datasourceId));
    };
    SiteUrls.prototype.datasourceConnectedWorkbooksPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceConnectedWorkbooksPart(datasourceId));
    };
    SiteUrls.datasourceConnectedWorkbooksPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourcePart(datasourceId)).concat(SiteUrls.connectedWorkbooksPart());
    };
    SiteUrls.connectedWorkbooksPart = function () {
        return '/connectedWorkbooks';
    };
    SiteUrls.prototype.datasourceDetailsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceDetailsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceDetailsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceDetailsPart(datasourceId));
    };
    SiteUrls.datasourceDetailsPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourcePart(datasourceId)).concat(SiteUrls.detailsPart());
    };
    SiteUrls.detailsPart = function () {
        return '/details';
    };
    SiteUrls.prototype.datasourceDataConnectionUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceDataConnectionPath(datasourceId));
    };
    SiteUrls.prototype.datasourceDataConnectionPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceDataConnectionPart(datasourceId));
    };
    SiteUrls.datasourceDataConnectionPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourcePart(datasourceId)).concat(SiteUrls.dataConnectionPart());
    };
    SiteUrls.dataConnectionPart = function () {
        return '/dataConnection';
    };
    SiteUrls.prototype.favoriteDatasourceUrl = function (datasourceId, datasourceIdForFavoriting) {
        return this.fullUrl(this.favoriteDatasourcePath(datasourceId, datasourceIdForFavoriting));
    };
    SiteUrls.prototype.favoriteDatasourcePath = function (datasourceId, datasourceIdForFavoriting) {
        return this.sitePath(SiteUrls.favoriteDatasourcePart(datasourceId, datasourceIdForFavoriting));
    };
    SiteUrls.favoriteDatasourcePart = function (datasourceId, datasourceIdForFavoriting) {
        return "/redirect_to_datasource/".concat(datasourceIdForFavoriting, "/").concat(datasourceId);
    };
    SiteUrls.prototype.favoriteDatasourceDoesntExistUrl = function (datasourceIdForFavoriting) {
        return this.fullUrl(this.favoriteDatasourceDoesntExistPath(datasourceIdForFavoriting));
    };
    SiteUrls.prototype.favoriteDatasourceDoesntExistPath = function (datasourceIdForFavoriting) {
        return this.sitePath(SiteUrls.favoriteDatasourceDoesntExistPart(datasourceIdForFavoriting));
    };
    SiteUrls.favoriteDatasourceDoesntExistPart = function (datasourceIdForFavoriting) {
        return "/redirect_to_removed_datasource/".concat(datasourceIdForFavoriting);
    };
    SiteUrls.prototype.datasourceLineageUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineagePath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineagePath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineagePart(datasourceId));
    };
    SiteUrls.datasourceLineagePart = function (datasourceId) {
        return "".concat(SiteUrls.datasourcePart(datasourceId)).concat(SiteUrls.lineagePart());
    };
    SiteUrls.prototype.datasourceLineageFieldsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageFieldsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageFieldsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageFieldsPart(datasourceId));
    };
    SiteUrls.datasourceLineageFieldsPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.fieldsPart());
    };
    SiteUrls.prototype.datasourceLineageFieldUrl = function (datasourceId, fieldId) {
        return this.fullUrl(this.datasourceLineageFieldPath(datasourceId, fieldId));
    };
    SiteUrls.prototype.datasourceLineageFieldPath = function (datasourceId, fieldId) {
        return this.sitePath(SiteUrls.datasourceLineageFieldPart(datasourceId, fieldId));
    };
    SiteUrls.datasourceLineageFieldPart = function (datasourceId, fieldId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.fieldsPart(), "/").concat(fieldId);
    };
    SiteUrls.prototype.datasourceLineageUpstreamDatabasesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageUpstreamDatabasesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageUpstreamDatabasesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageUpstreamDatabasesPart(datasourceId));
    };
    SiteUrls.datasourceLineageUpstreamDatabasesPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.datasourceLineageUpstreamTablesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageUpstreamTablesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageUpstreamTablesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageUpstreamTablesPart(datasourceId));
    };
    SiteUrls.datasourceLineageUpstreamTablesPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.datasourceLineageUpstreamVirtualConnectionsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageUpstreamVirtualConnectionsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageUpstreamVirtualConnectionsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageUpstreamVirtualConnectionsPart(datasourceId));
    };
    SiteUrls.datasourceLineageUpstreamVirtualConnectionsPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.virtualConnectionsPart());
    };
    SiteUrls.prototype.datasourceLineageUpstreamVirtualConnectionTablesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageUpstreamVirtualConnectionTablesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageUpstreamVirtualConnectionTablesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageUpstreamVirtualConnectionTablesPart(datasourceId));
    };
    SiteUrls.datasourceLineageUpstreamVirtualConnectionTablesPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.virtualConnectionTablesPart());
    };
    SiteUrls.prototype.datasourceLineageUpstreamFlowsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageUpstreamFlowsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageUpstreamFlowsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageUpstreamFlowsPart(datasourceId));
    };
    SiteUrls.datasourceLineageUpstreamFlowsPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.datasourceLineageUpstreamDatasourcesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageUpstreamDatasourcesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageUpstreamDatasourcesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageUpstreamDatasourcesPart(datasourceId));
    };
    SiteUrls.datasourceLineageUpstreamDatasourcesPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.upstreamPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.datasourceLineageDownstreamDatabasesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamDatabasesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamDatabasesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamDatabasesPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamDatabasesPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.datasourceLineageDownstreamTablesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamTablesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamTablesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamTablesPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamTablesPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.datasourceLineageDownstreamFlowsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamFlowsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamFlowsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamFlowsPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamFlowsPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.datasourceLineageDownstreamMetricDefinitionsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamMetricDefinitionsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamMetricDefinitionsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamMetricDefinitionsPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamMetricDefinitionsPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.metricDefinitionsPart());
    };
    SiteUrls.prototype.datasourceLineageDownstreamDatasourcesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamDatasourcesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamDatasourcesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamDatasourcesPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamDatasourcesPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.datasourceLineageDownstreamLensesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamLensesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamLensesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamLensesPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamLensesPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lensesPart());
    };
    SiteUrls.prototype.datasourceLineageDownstreamWorkbooksUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamWorkbooksPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamWorkbooksPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamWorkbooksPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamWorkbooksPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.workbooksPart());
    };
    SiteUrls.prototype.datasourceLineageDownstreamDashboardsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamDashboardsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamDashboardsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamDashboardsPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamDashboardsPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.dashboardsPart());
    };
    SiteUrls.prototype.datasourceLineageDownstreamSheetsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamSheetsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamSheetsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamSheetsPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamSheetsPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.sheetsPart());
    };
    SiteUrls.prototype.datasourceLineageDownstreaMetricsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamMetricsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamMetricsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamMetricsPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamMetricsPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.lineageMetricsPart());
    };
    SiteUrls.prototype.datasourceLineageDownstreamOwnersUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamOwnersPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamOwnersPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamOwnersPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamOwnersPart = function (datasourceId) {
        return "".concat(SiteUrls.datasourceLineagePart(datasourceId)).concat(SiteUrls.downstreamPart()).concat(SiteUrls.ownersPart());
    };
    // Groups
    SiteUrls.prototype.groupsUrl = function () {
        return this.fullUrl(this.groupsPath());
    };
    SiteUrls.prototype.groupsPath = function () {
        return this.sitePath(SiteUrls.groupsPart());
    };
    SiteUrls.groupsPart = function () {
        return '/groups';
    };
    SiteUrls.prototype.groupUrl = function (groupId) {
        return this.fullUrl(this.groupPath(groupId));
    };
    SiteUrls.prototype.groupPath = function (groupId) {
        return this.sitePath(SiteUrls.groupPart(groupId));
    };
    SiteUrls.groupPart = function (groupId) {
        return "".concat(SiteUrls.groupsPart(), "/").concat(groupId);
    };
    SiteUrls.prototype.groupUsersUrl = function (groupId) {
        return this.fullUrl(this.groupUsersPath(groupId));
    };
    SiteUrls.prototype.groupUsersPath = function (groupId) {
        return this.sitePath(SiteUrls.groupUsersPart(groupId));
    };
    SiteUrls.groupUsersPart = function (groupId) {
        return "".concat(SiteUrls.groupPart(groupId)).concat(SiteUrls.usersPart());
    };
    SiteUrls.prototype.groupDetailsUrl = function (groupId) {
        return this.fullUrl(this.groupDetailsPath(groupId));
    };
    SiteUrls.prototype.groupDetailsPath = function (groupId) {
        return this.sitePath(SiteUrls.groupDetailsPart(groupId));
    };
    SiteUrls.groupDetailsPart = function (groupId) {
        return "".concat(SiteUrls.groupPart(groupId)).concat(SiteUrls.detailsPart());
    };
    // Group Sets
    SiteUrls.prototype.groupSetsUrl = function () {
        return this.fullUrl(this.groupSetsPath());
    };
    SiteUrls.prototype.groupSetsPath = function () {
        return this.sitePath(SiteUrls.groupSetsPart());
    };
    SiteUrls.groupSetsPart = function () {
        return '/groupsets';
    };
    SiteUrls.prototype.groupSetUrl = function (groupSetId) {
        return this.fullUrl(this.groupSetPath(groupSetId));
    };
    SiteUrls.prototype.groupSetPath = function (groupSetId) {
        return this.sitePath(SiteUrls.groupSetPart(groupSetId));
    };
    SiteUrls.groupSetPart = function (groupSetId) {
        return "".concat(SiteUrls.groupSetsPart(), "/").concat(groupSetId);
    };
    SiteUrls.prototype.groupSetGroupsUrl = function (groupSetId) {
        return this.fullUrl(this.groupSetGroupsPath(groupSetId));
    };
    SiteUrls.prototype.groupSetGroupsPath = function (groupSetId) {
        return this.sitePath(SiteUrls.groupSetGroupsPart(groupSetId));
    };
    SiteUrls.groupSetGroupsPart = function (groupSetId) {
        return "".concat(SiteUrls.groupSetPart(groupSetId)).concat(SiteUrls.groupsPart());
    };
    SiteUrls.prototype.groupSetDetailsUrl = function (groupSetId) {
        return this.fullUrl(this.groupSetDetailsPath(groupSetId));
    };
    SiteUrls.prototype.groupSetDetailsPath = function (groupSetId) {
        return this.sitePath(SiteUrls.groupSetDetailsPart(groupSetId));
    };
    SiteUrls.groupSetDetailsPart = function (groupSetId) {
        return "".concat(SiteUrls.groupSetPart(groupSetId)).concat(SiteUrls.detailsPart());
    };
    // Broadcasts
    SiteUrls.prototype.broadcastsUrl = function () {
        return this.fullUrl(this.broadcastsPath());
    };
    SiteUrls.prototype.broadcastsPath = function () {
        return this.sitePath(SiteUrls.broadcastsPart());
    };
    SiteUrls.broadcastsPart = function () {
        return '/broadcasts';
    };
    // Schedules
    SiteUrls.prototype.schedulesUrl = function () {
        return this.fullUrl(this.schedulesPath());
    };
    SiteUrls.prototype.schedulesPath = function () {
        return this.sitePath(SiteUrls.schedulesPart());
    };
    SiteUrls.schedulesPart = function () {
        return '/schedules';
    };
    SiteUrls.prototype.scheduleUrl = function (scheduleId) {
        return this.fullUrl(this.schedulePath(scheduleId));
    };
    SiteUrls.prototype.schedulePath = function (scheduleId) {
        return this.sitePath(SiteUrls.schedulePart(scheduleId));
    };
    SiteUrls.schedulePart = function (scheduleId) {
        return "".concat(SiteUrls.schedulesPart(), "/").concat(scheduleId);
    };
    // public scheduleExtractRefreshesUrl(scheduleId: string): string {
    //   return this.scheduleUrl(scheduleId) + '/extractRefreshes';
    // }
    SiteUrls.prototype.scheduleExtractRefreshesUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleExtractRefreshesPath(scheduleId));
    };
    SiteUrls.prototype.scheduleExtractRefreshesPath = function (scheduleId) {
        return this.sitePath(SiteUrls.scheduleExtractRefreshesPart(scheduleId));
    };
    SiteUrls.scheduleExtractRefreshesPart = function (scheduleId) {
        return "".concat(SiteUrls.schedulePart(scheduleId)).concat(SiteUrls.extractRefreshesPart());
    };
    SiteUrls.extractRefreshesPart = function () {
        return '/extractRefreshes';
    };
    SiteUrls.prototype.scheduleFlowsUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleFlowsPath(scheduleId));
    };
    SiteUrls.prototype.scheduleFlowsPath = function (scheduleId) {
        return this.sitePath(SiteUrls.scheduleFlowsPart(scheduleId));
    };
    SiteUrls.scheduleFlowsPart = function (scheduleId) {
        return "".concat(SiteUrls.schedulePart(scheduleId)).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.scheduleSubscriptionsUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleSubscriptionsPath(scheduleId));
    };
    SiteUrls.prototype.scheduleSubscriptionsPath = function (scheduleId) {
        return this.sitePath(SiteUrls.scheduleSubscriptionsPart(scheduleId));
    };
    SiteUrls.scheduleSubscriptionsPart = function (scheduleId) {
        return "".concat(SiteUrls.schedulePart(scheduleId)).concat(SiteUrls.subscriptionsPart());
    };
    SiteUrls.subscriptionsPart = function () {
        return '/subscriptions';
    };
    SiteUrls.prototype.scheduleDataAccelerationUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleDataAccelerationPath(scheduleId));
    };
    SiteUrls.prototype.scheduleDataAccelerationPath = function (scheduleId) {
        return this.sitePath(SiteUrls.scheduleDataAccelerationPart(scheduleId));
    };
    SiteUrls.scheduleDataAccelerationPart = function (scheduleId) {
        return "".concat(SiteUrls.schedulePart(scheduleId)).concat(SiteUrls.dataAccelerationPart());
    };
    SiteUrls.prototype.scheduleDetailsUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleDetailsPath(scheduleId));
    };
    SiteUrls.prototype.scheduleDetailsPath = function (scheduleId) {
        return this.sitePath(SiteUrls.scheduleDetailsPart(scheduleId));
    };
    SiteUrls.scheduleDetailsPart = function (scheduleId) {
        return "".concat(SiteUrls.schedulePart(scheduleId)).concat(SiteUrls.detailsPart());
    };
    // Jobs
    SiteUrls.prototype.jobsUrl = function () {
        return this.fullUrl(this.jobsPath());
    };
    SiteUrls.prototype.jobsPath = function () {
        return this.sitePath(SiteUrls.jobsPart());
    };
    SiteUrls.jobsPart = function () {
        return '/jobs';
    };
    // Labels
    SiteUrls.prototype.labelsUrl = function () {
        return this.fullUrl(this.labelsPath());
    };
    SiteUrls.prototype.labelsPath = function () {
        return this.sitePath(SiteUrls.labelsPart());
    };
    SiteUrls.labelsPart = function () {
        return '/labels';
    };
    // Favorites
    SiteUrls.prototype.favoritesUrl = function () {
        return this.fullUrl(this.favoritesPath());
    };
    SiteUrls.prototype.favoritesPath = function () {
        return this.sitePath(SiteUrls.favoritesPart());
    };
    SiteUrls.favoritesPart = function () {
        return '/favorites';
    };
    // Recents
    SiteUrls.prototype.recentsUrl = function () {
        return this.fullUrl(this.recentsPath());
    };
    SiteUrls.prototype.recentsPath = function () {
        return this.sitePath(SiteUrls.recentsPart());
    };
    SiteUrls.recentsPart = function () {
        return '/recents';
    };
    // search
    SiteUrls.prototype.searchUrl = function () {
        return this.fullUrl(this.searchPath());
    };
    SiteUrls.prototype.searchPath = function () {
        return this.sitePath(SiteUrls.searchPart());
    };
    SiteUrls.searchPart = function () {
        return '/search';
    };
    SiteUrls.prototype.searchViewsUrl = function () {
        return this.fullUrl(this.searchViewsPath());
    };
    SiteUrls.prototype.searchViewsPath = function () {
        return this.sitePath(SiteUrls.searchViewsPart());
    };
    SiteUrls.searchViewsPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.viewsPart());
    };
    SiteUrls.prototype.searchMetricsUrl = function () {
        return this.fullUrl(this.searchMetricsPath());
    };
    SiteUrls.prototype.searchMetricsPath = function () {
        return this.sitePath(SiteUrls.searchMetricsPart());
    };
    SiteUrls.searchMetricsPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.metricsPart());
    };
    SiteUrls.prototype.searchWorkbooksUrl = function () {
        return this.fullUrl(this.searchWorkbooksPath());
    };
    SiteUrls.prototype.searchWorkbooksPath = function () {
        return this.sitePath(SiteUrls.searchWorkbooksPart());
    };
    SiteUrls.searchWorkbooksPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.workbooksPart());
    };
    SiteUrls.prototype.searchDatasourcesUrl = function () {
        return this.fullUrl(this.searchDatasourcesPath());
    };
    SiteUrls.prototype.searchDatasourcesPath = function () {
        return this.sitePath(SiteUrls.searchDatasourcesPart());
    };
    SiteUrls.searchDatasourcesPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.datasourcesPart());
    };
    SiteUrls.prototype.searchProjectsUrl = function () {
        return this.fullUrl(this.searchProjectsPath());
    };
    SiteUrls.prototype.searchProjectsPath = function () {
        return this.sitePath(SiteUrls.searchProjectsPart());
    };
    SiteUrls.searchProjectsPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.projectsPart());
    };
    SiteUrls.prototype.searchFlowsUrl = function () {
        return this.fullUrl(this.searchFlowsPath());
    };
    SiteUrls.prototype.searchFlowsPath = function () {
        return this.sitePath(SiteUrls.searchFlowsPart());
    };
    SiteUrls.searchFlowsPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.searchTablesUrl = function () {
        return this.fullUrl(this.searchTablesPath());
    };
    SiteUrls.prototype.searchTablesPath = function () {
        return this.sitePath(SiteUrls.searchTablesPart());
    };
    SiteUrls.searchTablesPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.tablesPart());
    };
    SiteUrls.prototype.searchDatabasesUrl = function () {
        return this.fullUrl(this.searchDatabasesPath());
    };
    SiteUrls.prototype.searchDatabasesPath = function () {
        return this.sitePath(SiteUrls.searchDatabasesPart());
    };
    SiteUrls.searchDatabasesPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.databasesPart());
    };
    SiteUrls.prototype.searchDataRolesUrl = function () {
        return this.fullUrl(this.searchDataRolesPath());
    };
    SiteUrls.prototype.searchDataRolesPath = function () {
        return this.sitePath(SiteUrls.searchDataRolesPart());
    };
    SiteUrls.searchDataRolesPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.dataRolesPart());
    };
    SiteUrls.prototype.searchLensesUrl = function () {
        return this.fullUrl(this.searchLensesPath());
    };
    SiteUrls.prototype.searchLensesPath = function () {
        return this.sitePath(SiteUrls.searchLensesPart());
    };
    SiteUrls.searchLensesPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.lensesPart());
    };
    SiteUrls.prototype.searchCollectionsUrl = function () {
        return this.fullUrl(this.searchCollectionsPath());
    };
    SiteUrls.prototype.searchCollectionsPath = function () {
        return this.sitePath(SiteUrls.searchCollectionsPart());
    };
    SiteUrls.searchCollectionsPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.collectionsPath());
    };
    SiteUrls.prototype.searchUsersUrl = function () {
        return this.fullUrl(this.searchUsersPath());
    };
    SiteUrls.prototype.searchUsersPath = function () {
        return this.sitePath(SiteUrls.searchUsersPart());
    };
    SiteUrls.searchUsersPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.usersPart());
    };
    SiteUrls.prototype.searchVirtualConnectionsUrl = function () {
        return this.fullUrl(this.searchVirtualConnectionsPath());
    };
    SiteUrls.prototype.searchVirtualConnectionsPath = function () {
        return this.sitePath(SiteUrls.searchVirtualConnectionsPart());
    };
    SiteUrls.searchVirtualConnectionsPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.virtualConnectionsPart());
    };
    SiteUrls.prototype.searchVirtualConnectionTablesUrl = function () {
        return this.fullUrl(this.searchVirtualConnectionTablesPath());
    };
    SiteUrls.prototype.searchVirtualConnectionTablesPath = function () {
        return this.sitePath(SiteUrls.searchVirtualConnectionTablesPart());
    };
    SiteUrls.searchVirtualConnectionTablesPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.virtualConnectionTablesPart());
    };
    SiteUrls.prototype.searchPredictiveModelsUrl = function () {
        return this.fullUrl(this.searchPredictiveModelsPath());
    };
    SiteUrls.prototype.searchPredictiveModelsPath = function () {
        return this.sitePath(SiteUrls.searchPredictiveModelsPart());
    };
    SiteUrls.searchPredictiveModelsPart = function () {
        return "".concat(SiteUrls.searchPart()).concat(SiteUrls.predictiveModelsPart());
    };
    // Others
    SiteUrls.prototype.settingsUrl = function () {
        return this.fullUrl(this.settingsPath());
    };
    SiteUrls.prototype.settingsPath = function () {
        return this.sitePath(SiteUrls.settingsPart());
    };
    SiteUrls.settingsPart = function () {
        return '/settings';
    };
    SiteUrls.prototype.settingsAuthenticationUrl = function () {
        return this.fullUrl(this.settingsAuthenticationPath());
    };
    SiteUrls.prototype.settingsAuthenticationPath = function () {
        return this.sitePath(SiteUrls.authenticationPart());
    };
    SiteUrls.authenticationPart = function () {
        return '/authentication';
    };
    SiteUrls.prototype.settingsBridgeUrl = function () {
        return this.fullUrl(this.settingsBridgePath());
    };
    SiteUrls.prototype.settingsBridgePath = function () {
        return this.sitePath(SiteUrls.bridgePart());
    };
    SiteUrls.bridgePart = function () {
        return '/bridge';
    };
    SiteUrls.prototype.settingsDataConnectUrl = function () {
        return this.fullUrl(this.settingsDataConnectPath());
    };
    SiteUrls.prototype.settingsDataConnectPath = function () {
        return this.sitePath(SiteUrls.dataConnectPart());
    };
    SiteUrls.dataConnectPart = function () {
        return '/dataconnect';
    };
    SiteUrls.prototype.settingsExtensionsUrl = function () {
        return this.fullUrl(this.settingsExtensionsPath());
    };
    SiteUrls.prototype.settingsExtensionsPath = function () {
        return this.sitePath(SiteUrls.extensionsPart());
    };
    SiteUrls.extensionsPart = function () {
        return '/extensions';
    };
    SiteUrls.prototype.settingsIntegrationsUrl = function () {
        return this.fullUrl(this.settingsIntegrationsPath());
    };
    SiteUrls.prototype.settingsIntegrationsPath = function () {
        return this.sitePath(SiteUrls.integrationsPart());
    };
    SiteUrls.integrationsPart = function () {
        return '/integrations';
    };
    SiteUrls.prototype.settingsConnectedApplicationsUrl = function () {
        return this.fullUrl(this.settingsConnectedApplicationsPath());
    };
    SiteUrls.prototype.settingsConnectedApplicationsPath = function () {
        return this.sitePath(SiteUrls.connectedApplicationsPart());
    };
    SiteUrls.connectedApplicationsPart = function () {
        return '/connectedApplications';
    };
    SiteUrls.directTrustPart = function () {
        return '/directTrust';
    };
    SiteUrls.externalAuthorizationServersPart = function () {
        return '/externalAuthorizationServers';
    };
    SiteUrls.prototype.settingsMobileUrl = function () {
        return this.fullUrl(this.settingsMobilePath());
    };
    SiteUrls.prototype.settingsMobilePath = function () {
        return this.sitePath(SiteUrls.MobilePart());
    };
    SiteUrls.MobilePart = function () {
        return '/mobile';
    };
    SiteUrls.prototype.settingsPrivateConnectUrl = function () {
        return this.fullUrl(this.settingsPrivateConnectPath());
    };
    SiteUrls.prototype.settingsPrivateConnectPath = function () {
        return this.sitePath(SiteUrls.PrivateConnectPart());
    };
    SiteUrls.PrivateConnectPart = function () {
        return '/privateconnect';
    };
    SiteUrls.prototype.statusUrl = function () {
        return this.fullUrl(this.statusPath());
    };
    SiteUrls.prototype.statusPath = function () {
        return this.sitePath(SiteUrls.statusPart());
    };
    SiteUrls.statusPart = function () {
        return '/status';
    };
    // Tasks
    SiteUrls.prototype.tasksUrl = function () {
        return this.fullUrl(this.tasksPath());
    };
    SiteUrls.prototype.tasksPath = function () {
        return this.sitePath(SiteUrls.tasksPart());
    };
    SiteUrls.tasksPart = function () {
        return '/tasks';
    };
    SiteUrls.prototype.tasksExtractRefreshesUrl = function () {
        return this.fullUrl(this.tasksExtractRefreshesPath());
    };
    SiteUrls.prototype.tasksExtractRefreshesPath = function () {
        return this.sitePath(SiteUrls.tasksExtractRefreshesPart());
    };
    SiteUrls.tasksExtractRefreshesPart = function () {
        return "".concat(SiteUrls.tasksPart()).concat(SiteUrls.extractRefreshesPart());
    };
    SiteUrls.prototype.tasksFlowsUrl = function () {
        return this.fullUrl(this.tasksFlowsPath());
    };
    SiteUrls.prototype.tasksFlowsPath = function () {
        return this.sitePath(SiteUrls.tasksFlowsPart());
    };
    SiteUrls.tasksFlowsPart = function () {
        return "".concat(SiteUrls.tasksPart()).concat(SiteUrls.flowsPart());
    };
    SiteUrls.prototype.tasksSubscriptionsUrl = function () {
        return this.fullUrl(this.tasksSubscriptionsPath());
    };
    SiteUrls.prototype.tasksSubscriptionsPath = function () {
        return this.sitePath(SiteUrls.tasksSubscriptionsPart());
    };
    SiteUrls.tasksSubscriptionsPart = function () {
        return "".concat(SiteUrls.tasksPart()).concat(SiteUrls.subscriptionsPart());
    };
    SiteUrls.prototype.tasksDataAlertsUrl = function () {
        return this.fullUrl(this.tasksDataAlertsPath());
    };
    SiteUrls.prototype.tasksDataAlertsPath = function () {
        return this.sitePath(SiteUrls.tasksDataAlertsPart());
    };
    SiteUrls.tasksDataAlertsPart = function () {
        return "".concat(SiteUrls.tasksPart()).concat(SiteUrls.dataAlertsPart());
    };
    SiteUrls.prototype.tasksDataAccelerationUrl = function () {
        return this.fullUrl(this.tasksDataAccelerationPath());
    };
    SiteUrls.prototype.tasksDataAccelerationPath = function () {
        return this.sitePath(SiteUrls.tasksDataAccelerationPart());
    };
    SiteUrls.tasksDataAccelerationPart = function () {
        return "".concat(SiteUrls.tasksPart()).concat(SiteUrls.dataAccelerationPart());
    };
    SiteUrls.dataAccelerationPart = function () {
        return '/dataAcceleration';
    };
    SiteUrls.prototype.tasksLinkedTasksUrl = function () {
        return this.fullUrl(this.tasksLinkedTasksPath());
    };
    SiteUrls.prototype.tasksLinkedTasksPath = function () {
        return this.sitePath(SiteUrls.tasksLinkedTasksPart());
    };
    SiteUrls.tasksLinkedTasksPart = function () {
        return "".concat(SiteUrls.tasksPart()).concat(SiteUrls.linkedTasksPart());
    };
    SiteUrls.linkedTasksPart = function () {
        return '/linkedTasks';
    };
    // Home
    SiteUrls.prototype.homeUrl = function () {
        return this.fullUrl(this.homePath());
    };
    SiteUrls.prototype.homePath = function () {
        return this.sitePath(SiteUrls.homePart());
    };
    SiteUrls.homePart = function () {
        return '/home';
    };
    // Sandbox
    SiteUrls.prototype.sandboxUrl = function () {
        return this.fullUrl(this.sandboxPath());
    };
    SiteUrls.prototype.sandboxPath = function () {
        return this.sitePath(SiteUrls.sandboxPart());
    };
    SiteUrls.sandboxPart = function () {
        return '/sandbox';
    };
    // Metrics
    SiteUrls.prototype.metricsUrl = function () {
        return this.fullUrl(this.metricsPath());
    };
    SiteUrls.prototype.metricsPath = function () {
        return this.sitePath(SiteUrls.metricsPart());
    };
    SiteUrls.metricsPart = function () {
        return '/metrics';
    };
    SiteUrls.prototype.metricUrl = function (metricId) {
        return this.fullUrl(this.metricPath(metricId));
    };
    SiteUrls.prototype.metricPath = function (metricId) {
        return this.sitePath(SiteUrls.metricPart(metricId));
    };
    SiteUrls.metricPart = function (metricId) {
        return "".concat(SiteUrls.metricsPart(), "/").concat(metricId);
    };
    SiteUrls.prototype.favoriteMetricUrl = function (metricId) {
        return this.redirectToMetricUrl(metricId);
    };
    SiteUrls.prototype.redirectToMetricUrl = function (metricId) {
        return this.fullUrl(this.redirectToMetricPath(metricId));
    };
    SiteUrls.prototype.redirectToMetricPath = function (metricId) {
        return this.sitePath(SiteUrls.redirectToMetricPart(metricId));
    };
    SiteUrls.redirectToMetricPart = function (metricId) {
        return "/redirect_to_metric/".concat(metricId);
    };
    // Site Status Vizzes
    SiteUrls.prototype.siteStatusVizUrl = function (sheetUrlId) {
        return this.fullUrl(this.siteStatusVizPath(sheetUrlId));
    };
    SiteUrls.prototype.siteStatusVizPath = function (sheetUrlId) {
        return this.sitePath(SiteUrls.siteStatusVizPart(sheetUrlId));
    };
    SiteUrls.siteStatusVizPart = function (sheetUrlId) {
        return "/analysis/".concat(sheetUrlId);
    };
    // Workbook Revision History
    SiteUrls.prototype.workbookRevisionHistoryUrl = function (params) {
        return this.fullUrl(this.workbookRevisionHistoryPath(params));
    };
    SiteUrls.prototype.workbookRevisionHistoryPath = function (params) {
        return this.sitePath(SiteUrls.workbookRevisionHistoryPart(params));
    };
    SiteUrls.workbookRevisionHistoryPart = function (params) {
        return "".concat(SiteUrls.workbooksPart(), "/").concat(params.workbookUrlId, "/history/").concat(params.revisionNumber);
    };
    SiteUrls.prototype.workbookRevisionHistorySpecificSheetUrl = function (params) {
        return this.fullUrl(this.workbookRevisionHistorySpecificSheetPath(params));
    };
    SiteUrls.prototype.workbookRevisionHistorySpecificSheetPath = function (params) {
        return this.sitePath(SiteUrls.workbookRevisionHistorySpecificSheetPart(params));
    };
    SiteUrls.workbookRevisionHistorySpecificSheetPart = function (params) {
        return "".concat(SiteUrls.workbooksPart(), "/").concat(params.workbookUrlId, "/").concat(params.sheetUrlId, "/history/").concat(params.revisionNumber);
    };
    SiteUrls.prototype.addUserToDataAlertUrl = function (dataAlertId) {
        return this.fullUrl(this.addUserToDataAlertPath(dataAlertId));
    };
    SiteUrls.prototype.addUserToDataAlertPath = function (dataAlertId) {
        return this.sitePath(SiteUrls.addUserToDataAlertPart(dataAlertId));
    };
    SiteUrls.addUserToDataAlertPart = function (dataAlertId) {
        return "/dataAlert/".concat(dataAlertId, "/addUser/");
    };
    SiteUrls.prototype.removeUserFromDataAlertUrl = function (dataAlertId) {
        return this.fullUrl(this.removeUserFromDataAlertPath(dataAlertId));
    };
    SiteUrls.prototype.removeUserFromDataAlertPath = function (dataAlertId) {
        return this.sitePath(SiteUrls.removeUserFromDataAlertPart(dataAlertId));
    };
    SiteUrls.removeUserFromDataAlertPart = function (dataAlertId) {
        return "/dataAlert/".concat(dataAlertId, "/removeUser/");
    };
    SiteUrls.prototype.dataAlertPath = function () {
        return this.sitePath(SiteUrls.dataAlertPart());
    };
    SiteUrls.dataAlertPart = function () {
        return '/dataAlert';
    };
    // Collections
    SiteUrls.prototype.collectionsUrl = function () {
        return this.fullUrl(this.collectionsPath());
    };
    SiteUrls.prototype.collectionsPath = function () {
        return this.sitePath(SiteUrls.collectionsPath());
    };
    SiteUrls.collectionsPath = function () {
        return '/collections';
    };
    SiteUrls.performancePath = function () {
        return '/performance';
    };
    SiteUrls.prototype.collectionUrl = function (collectionLuid) {
        return this.fullUrl(this.collectionPath(collectionLuid));
    };
    SiteUrls.prototype.collectionPath = function (collectionLuid) {
        return this.sitePath(SiteUrls.collectionPart(collectionLuid));
    };
    SiteUrls.collectionPart = function (collectionLuid) {
        return "".concat(SiteUrls.collectionsPath(), "/").concat(collectionLuid);
    };
    SiteUrls.prototype.redirectToCollectionUrl = function (collectionId, collectionLuid) {
        return this.fullUrl(this.redirectToCollectionPath(collectionId, collectionLuid));
    };
    SiteUrls.prototype.redirectToCollectionPath = function (collectionId, collectionLuid) {
        return this.sitePath(SiteUrls.redirectToCollectionPart(collectionId, collectionLuid));
    };
    SiteUrls.redirectToCollectionPart = function (collectionId, collectionLuid) {
        return "/redirect_to_collection/".concat(collectionId, "/").concat(collectionLuid);
    };
    SiteUrls.prototype.allCollectionsUrl = function () {
        return this.fullUrl(this.allCollectionsPath());
    };
    SiteUrls.prototype.allCollectionsPath = function () {
        return this.sitePath(SiteUrls.allCollectionsPart());
    };
    SiteUrls.allCollectionsPart = function () {
        return "".concat(this.collectionsPath(), "/allCollections");
    };
    SiteUrls.prototype.myCollectionsUrl = function () {
        return this.fullUrl(this.myCollectionsPath());
    };
    SiteUrls.prototype.myCollectionsPath = function () {
        return this.sitePath(SiteUrls.myCollectionsPart());
    };
    SiteUrls.myCollectionsPart = function () {
        return "".concat(this.collectionsPath(), "/myCollections");
    };
    // VizClient
    // Note that VizClient links do not preserve URL query parameters.
    SiteUrls.prototype.vizClientSitePath = function (path) {
        return "".concat(this.vizClientSitePrefix).concat(path);
    };
    SiteUrls.makeVizClientSitePrefix = function (siteUrlName) {
        return siteUrlName && siteUrlName.length > 0 ? "/t/".concat(siteUrlName) : '';
    };
    SiteUrls.prototype.newWorkbookUrl = function (projectName) {
        return this.newWorkbookUrlFromAuxiliaryId(this.generateUniqueAuxiliaryId(), projectName);
    };
    SiteUrls.prototype.newWorkbookFromDatabase = function (databaseId) {
        return "".concat(this.newWorkbookUrl(), "?:graphQLDatabaseId=").concat(databaseId);
    };
    SiteUrls.prototype.newWorkbookFromTable = function (tableId) {
        return "".concat(this.newWorkbookUrl(), "?:graphQLTableId=").concat(tableId);
    };
    SiteUrls.prototype.unpublishedWorkbookUrl = function (auxiliaryId, projectName) {
        return this.newWorkbookUrlFromAuxiliaryId(auxiliaryId, projectName);
    };
    SiteUrls.prototype.newWorkbookUrlFromAuxiliaryId = function (auxiliaryId, projectName) {
        return this.vizClientSitePath("/newWorkbook/".concat(this.vizClientProjectPart(projectName)).concat(auxiliaryId));
    };
    SiteUrls.prototype.vizClientProjectPart = function (projectName) {
        return projectName && projectName.length > 0 ? "p/".concat(projectName, "/") : '';
    };
    // Shared with me
    SiteUrls.prototype.sharedWithMeUrl = function () {
        return this.fullUrl(this.sharedWithMePath());
    };
    SiteUrls.prototype.sharedWithMePath = function () {
        return this.sitePath(SiteUrls.sharedWithMePart());
    };
    SiteUrls.sharedWithMePart = function () {
        return '/sharedWithMe';
    };
    // Personal Space
    SiteUrls.prototype.personalSpaceUrl = function () {
        return this.fullUrl(this.personalSpacePath());
    };
    SiteUrls.prototype.personalSpacePath = function () {
        return this.sitePath(SiteUrls.personalSpacePart());
    };
    SiteUrls.personalSpacePart = function () {
        return '/personalSpace';
    };
    // Workbook Acceleration
    SiteUrls.prototype.workbookAccelerationsUrl = function (workbookId) {
        return this.fullUrl(this.workbookAccelerationsPath(workbookId));
    };
    SiteUrls.prototype.workbookAccelerationsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookAccelerationsPart(workbookId));
    };
    SiteUrls.workbookAccelerationsPart = function (workbookId) {
        return "".concat(SiteUrls.workbookPart(workbookId)).concat(SiteUrls.dataAccelerationPart());
    };
    // Starters
    SiteUrls.prototype.startersUrl = function () {
        return this.fullUrl(this.startersPath());
    };
    SiteUrls.prototype.startersPath = function () {
        return this.sitePath(SiteUrls.startersPart());
    };
    SiteUrls.startersPart = function () {
        return '/starters';
    };
    SiteUrls.prototype.startersByConnectionTypeUrl = function (connectionType) {
        return this.fullUrl(this.startersByConnectionTypePath(connectionType));
    };
    SiteUrls.prototype.startersByConnectionTypePath = function (connectionType) {
        return this.sitePath(SiteUrls.startersByConnectionTypePart(connectionType));
    };
    SiteUrls.startersByConnectionTypePart = function (connectionType) {
        return "".concat(SiteUrls.startersPart(), "/").concat(connectionType);
    };
    // Authentication
    SiteUrls.prototype.authenticationNewConfigurationPath = function () {
        return "".concat(this.settingsAuthenticationPath(), "/newConfiguration");
    };
    SiteUrls.prototype.authenticationEditConfigurationPath = function (configuration) {
        return "".concat(this.settingsAuthenticationPath(), "/editConfiguration/").concat(configuration);
    };
    SiteUrls.prototype.authenticationNewConfigurationUrl = function () {
        return "".concat(this.settingsAuthenticationUrl(), "/newConfiguration");
    };
    SiteUrls.prototype.authenticationEditConfigurationUrl = function (configuration) {
        return "".concat(this.settingsAuthenticationUrl(), "/editConfiguration/").concat(configuration);
    };
    // Connected Applications
    // TODO: Remove this path once references downstream are removed
    SiteUrls.prototype.connectedApplicationUrl = function (connectedApplicationId) {
        return this.fullUrl(this.connectedApplicationPath(connectedApplicationId));
    };
    SiteUrls.prototype.connectedApplicationPath = function (connectedApplicationId) {
        return this.sitePath(SiteUrls.connectedApplicationPart(connectedApplicationId));
    };
    SiteUrls.connectedApplicationPart = function (connectedApplicationId) {
        return "".concat(SiteUrls.connectedApplicationsPart(), "/").concat(connectedApplicationId);
    };
    SiteUrls.prototype.connectedApplicationDirectTrustUrl = function (connectedApplicationId) {
        return this.fullUrl(this.connectedApplicationDirectTrustPath(connectedApplicationId));
    };
    SiteUrls.prototype.connectedApplicationDirectTrustPath = function (connectedApplicationId) {
        return this.sitePath(SiteUrls.connectedApplicationDirectTrustPart(connectedApplicationId));
    };
    SiteUrls.connectedApplicationDirectTrustPart = function (connectedApplicationId) {
        return "".concat(SiteUrls.connectedApplicationsPart()).concat(SiteUrls.directTrustPart(), "/").concat(connectedApplicationId);
    };
    SiteUrls.prototype.connectedApplicationEasUrl = function (connectedApplicationId) {
        return this.fullUrl(this.connectedApplicationEasPath(connectedApplicationId));
    };
    SiteUrls.prototype.connectedApplicationEasPath = function (connectedApplicationId) {
        return this.sitePath(SiteUrls.connectedApplicationEasPart(connectedApplicationId));
    };
    SiteUrls.connectedApplicationEasPart = function (connectedApplicationId) {
        return "".concat(SiteUrls.connectedApplicationsPart()).concat(SiteUrls.externalAuthorizationServersPart(), "/").concat(connectedApplicationId);
    };
    // Predictive Model
    SiteUrls.prototype.predictiveModelsUrl = function () {
        return this.fullUrl(this.predictiveModelsPath());
    };
    SiteUrls.prototype.predictiveModelsPath = function () {
        return this.sitePath(SiteUrls.predictiveModelsPart());
    };
    SiteUrls.predictiveModelsPart = function () {
        return '/predictiveModels';
    };
    SiteUrls.prototype.predictiveModelUrl = function (id) {
        return this.fullUrl(this.predictiveModelPath(id));
    };
    SiteUrls.prototype.predictiveModelPath = function (id) {
        return this.sitePath(SiteUrls.predictiveModelPart(id));
    };
    SiteUrls.predictiveModelPart = function (id) {
        return "".concat(SiteUrls.predictiveModelsPart(), "/").concat(id);
    };
    SiteUrls.prototype.predictiveModelOverviewUrl = function (id) {
        return this.fullUrl(this.predictiveModelOverviewPath(id));
    };
    SiteUrls.prototype.predictiveModelOverviewPath = function (id) {
        return this.sitePath(SiteUrls.predictiveModelOverviewPart(id));
    };
    SiteUrls.predictiveModelOverviewPart = function (id) {
        return "".concat(SiteUrls.predictiveModelPart(id)).concat(SiteUrls.overviewPart());
    };
    SiteUrls.prototype.predictiveModelConnectionsUrl = function (id) {
        return this.fullUrl(this.predictiveModelConnectionsPath(id));
    };
    SiteUrls.prototype.predictiveModelConnectionsPath = function (id) {
        return this.sitePath(SiteUrls.predictiveModelConnectionsPart(id));
    };
    SiteUrls.predictiveModelConnectionsPart = function (id) {
        return "".concat(SiteUrls.predictiveModelPart(id)).concat(SiteUrls.connectionsPart());
    };
    SiteUrls.prototype.predictiveModelConnectedContentUrl = function (id) {
        return this.fullUrl(this.predictiveModelConnectedContentPath(id));
    };
    SiteUrls.prototype.predictiveModelConnectedContentPath = function (id) {
        return this.sitePath(SiteUrls.predictiveModelConnectedContentPart(id));
    };
    SiteUrls.predictiveModelConnectedContentPart = function (id) {
        return "".concat(SiteUrls.predictiveModelPart(id)).concat(SiteUrls.connectedContentPart());
    };
    SiteUrls.connectedContentPart = function () {
        return '/connectedContent';
    };
    // Predictive Model Editor
    SiteUrls.prototype.predictiveModelEditorUrl = function () {
        return this.fullUrl(this.predictiveModelEditorPath());
    };
    SiteUrls.prototype.predictiveModelEditorPath = function () {
        return this.sitePath(SiteUrls.predictiveModelEditorPart());
    };
    SiteUrls.predictiveModelEditorPart = function () {
        return '/predictive-model-editor';
    };
    // Request Access
    SiteUrls.prototype.collectionRequestAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.collectionRequestAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.collectionRequestAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.collectionRequestAccessPart(contentIdentifier));
    };
    SiteUrls.collectionRequestAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.requestAccessPart()).concat(this.collectionPart(contentIdentifier));
    };
    SiteUrls.prototype.datasourceRequestAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.datasourceRequestAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.datasourceRequestAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.datasourceRequestAccessPart(contentIdentifier));
    };
    SiteUrls.datasourceRequestAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.requestAccessPart()).concat(this.datasourcePart(contentIdentifier));
    };
    SiteUrls.prototype.flowRequestAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.flowRequestAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.flowRequestAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.flowRequestAccessPart(contentIdentifier));
    };
    SiteUrls.flowRequestAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.requestAccessPart()).concat(this.flowPart(contentIdentifier));
    };
    SiteUrls.prototype.metricRequestAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.metricRequestAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.metricRequestAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.metricRequestAccessPart(contentIdentifier));
    };
    SiteUrls.metricRequestAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.requestAccessPart()).concat(this.metricPart(contentIdentifier));
    };
    SiteUrls.prototype.projectRequestAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.projectRequestAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.projectRequestAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.projectRequestAccessPart(contentIdentifier));
    };
    SiteUrls.projectRequestAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.requestAccessPart()).concat(this.projectPart(contentIdentifier));
    };
    SiteUrls.prototype.viewRequestAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.viewRequestAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.viewRequestAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.viewRequestAccessPart(contentIdentifier));
    };
    SiteUrls.viewRequestAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.requestAccessPart()).concat(this.viewPart(contentIdentifier));
    };
    SiteUrls.prototype.workbookRequestAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.workbookRequestAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.workbookRequestAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.workbookRequestAccessPart(contentIdentifier));
    };
    SiteUrls.workbookRequestAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.requestAccessPart()).concat(this.workbookPart(contentIdentifier));
    };
    SiteUrls.prototype.virtualConnectionRequestAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.virtualConnectionRequestAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.virtualConnectionRequestAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.virtualConnectionRequestAccessPart(contentIdentifier));
    };
    SiteUrls.virtualConnectionRequestAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.requestAccessPart()).concat(this.virtualConnectionPart(contentIdentifier));
    };
    SiteUrls.prototype.virtualConnectionTableRequestAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.virtualConnectionTableRequestAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.virtualConnectionTableRequestAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.virtualConnectionTableRequestAccessPart(contentIdentifier));
    };
    SiteUrls.virtualConnectionTableRequestAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.requestAccessPart()).concat(this.virtualConnectionTablePart(contentIdentifier));
    };
    SiteUrls.requestAccessPart = function () {
        return '/requestAccess';
    };
    // Grant Access
    SiteUrls.prototype.workbookGrantAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.workbookGrantAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.workbookGrantAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.workbookGrantAccessPart(contentIdentifier));
    };
    SiteUrls.workbookGrantAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.workbookPart(contentIdentifier)).concat(SiteUrls.viewsPart()).concat(SiteUrls.grantAccessPart());
    };
    SiteUrls.prototype.viewGrantAccessUrl = function (workbookName, viewName) {
        return this.fullUrl(this.viewGrantAccessPath(workbookName, viewName));
    };
    SiteUrls.prototype.viewGrantAccessPath = function (workbookName, viewName) {
        return this.sitePath(SiteUrls.viewGrantAccessPart(workbookName, viewName));
    };
    SiteUrls.viewGrantAccessPart = function (workbookName, viewName) {
        return "".concat(SiteUrls.viewPart("".concat(workbookName, "/").concat(viewName))).concat(SiteUrls.grantAccessPart());
    };
    SiteUrls.prototype.projectGrantAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.projectGrantAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.projectGrantAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.projectGrantAccessPart(contentIdentifier));
    };
    SiteUrls.projectGrantAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.projectPart(contentIdentifier)).concat(SiteUrls.grantAccessPart());
    };
    SiteUrls.prototype.metricGrantAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.metricGrantAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.metricGrantAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.metricGrantAccessPart(contentIdentifier));
    };
    SiteUrls.metricGrantAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.metricPart(contentIdentifier)).concat(SiteUrls.grantAccessPart());
    };
    SiteUrls.prototype.flowGrantAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.flowGrantAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.flowGrantAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.flowGrantAccessPart(contentIdentifier));
    };
    SiteUrls.flowGrantAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.flowPart(contentIdentifier)).concat(SiteUrls.grantAccessPart());
    };
    SiteUrls.prototype.datasourceGrantAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.datasourceGrantAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.datasourceGrantAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.datasourceGrantAccessPart(contentIdentifier));
    };
    SiteUrls.datasourceGrantAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.datasourcePart(contentIdentifier)).concat(SiteUrls.dataConnectionPart()).concat(SiteUrls.grantAccessPart());
    };
    SiteUrls.prototype.collectionGrantAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.collectionGrantAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.collectionGrantAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.collectionGrantAccessPart(contentIdentifier));
    };
    SiteUrls.collectionGrantAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.collectionPart(contentIdentifier)).concat(SiteUrls.grantAccessPart());
    };
    SiteUrls.prototype.virtualConnectionGrantAccessUrl = function (contentIdentifier) {
        return this.fullUrl(this.virtualConnectionGrantAccessPath(contentIdentifier));
    };
    SiteUrls.prototype.virtualConnectionGrantAccessPath = function (contentIdentifier) {
        return this.sitePath(SiteUrls.virtualConnectionGrantAccessPart(contentIdentifier));
    };
    SiteUrls.virtualConnectionGrantAccessPart = function (contentIdentifier) {
        return "".concat(SiteUrls.virtualConnectionPart(contentIdentifier)).concat(SiteUrls.grantAccessPart());
    };
    SiteUrls.grantAccessPart = function () {
        return '/grantAccess';
    };
    // Path to Pulse (formerly NTBUE)
    SiteUrls.prototype.ntbuePath = function () {
        return this.sitePath(SiteUrls.ntbuePart() + '/');
    };
    SiteUrls.prototype.pulsePath = function () {
        return "".concat(SiteUrls.ntbuePart()).concat(this.sitePrefix, "/");
    };
    SiteUrls.ntbuePart = function () {
        return '/pulse';
    };
    // Path to metric definition in pulse
    // site/site-name/pulse/metricDefinitionID
    SiteUrls.prototype.pulseMetricDefinitionPath = function (metricDefinitionID) {
        return this.sitePath(SiteUrls.pulseMetricDefinitionPart(metricDefinitionID));
    };
    SiteUrls.pulseMetricDefinitionPart = function (metricDefinitionID) {
        return "".concat(SiteUrls.ntbuePart(), "/").concat(metricDefinitionID);
    };
    SiteUrls.metricDefinitionsPart = function () {
        return '/metricDefinitions';
    };
    // This code was copied from VizPortal Client and is consumed by at least one other repository.
    // This isn't logically the right place for this sort of logic, but there isn't currently a better place.
    SiteUrls.prototype.generateUniqueAuxiliaryId = function () {
        var base36Digit = function () {
            var s = '0123456789abcdefghijklmnopqrstuvwxyz';
            return s[Math.floor(Math.random() * s.length)];
        };
        var b36 = function (len) {
            var s = '';
            for (var i = 0; i < len; ++i) {
                s += base36Digit();
            }
            return s;
        };
        // To generate the auxiliary ID, use a base-32 encoding of the client time-stamp plus a guid-like base-36 pseudo-unique identifier.
        // We use half the number of digits compared to a standard GUID since base-36 has over twice the number of encoding bits.
        // A collision of identifiers generated in this way is virtually impossible.
        return (new Date().getTime().toString(32).toLowerCase() +
            '$' +
            b36(4) +
            '-' +
            b36(2) +
            '-' +
            b36(2) +
            '-' +
            b36(2) +
            '-' +
            b36(6));
    };
    return SiteUrls;
}());
exports.SiteUrls = SiteUrls;
//# sourceMappingURL=SiteUrls.js.map